import ne from "@arcgis/core/layers/FeatureLayer";
import S from "@arcgis/core/Graphic";
import sr from "dompurify";
import Te from "@arcgis/core/geometry/Polygon";
import qe from "@arcgis/core/geometry/SpatialReference";
import F from "@arcgis/core/request";
import { createLogger as Ge } from "@origo/logger";
import * as dr from "@arcgis/core/geometry/operators/areaOperator";
import * as ar from "@arcgis/core/geometry/operators/intersectionOperator";
import * as ir from "@arcgis/core/geometry/operators/intersectsOperator";
import { queryOptions as T, useQuery as G, useQueryClient as b, useMutation as v } from "@tanstack/react-query";
import { z as j } from "zod";
import { jsx as lr } from "react/jsx-runtime";
import { createContext as ur, useMemo as mr, useContext as he } from "react";
class R extends Error {
  constructor(r, t) {
    super(r), this.name = this.constructor.name, this.cause = t;
  }
}
class oe extends R {
  constructor(r) {
    super(`Fant ikke seksjon med GlobalID=${r}`), this.globalId = r, this.code = "SECTION_NOT_FOUND";
  }
}
class Ce extends R {
  constructor(r) {
    super(`Fant ikke område med id=${r}`), this.områdeId = r, this.code = "OMRÅDE_NOT_FOUND";
  }
}
class cr extends R {
  constructor() {
    super(...arguments), this.code = "OVERRIDE_CONFLICT";
  }
}
class pr extends R {
  constructor(r) {
    super(`Sirkulær referanse oppdaget i område-hierarki for id=${r}`), this.områdeId = r, this.code = "OMRÅDE_CYCLE";
  }
}
class q extends R {
  constructor(r, t = {}) {
    super(r), this.fieldErrors = t, this.code = "VALIDATION";
  }
}
class C extends R {
  constructor() {
    super(...arguments), this.code = "CONFIGURATION";
  }
}
class k extends R {
  constructor() {
    super(...arguments), this.code = "NETWORK";
  }
}
class fr extends R {
  constructor(r = "Mangler eller utløpt autentisering", t) {
    super(r, t), this.code = "AUTH";
  }
}
class P extends R {
  constructor() {
    super("Operasjonen ble avbrutt"), this.code = "ABORTED";
  }
}
function W(e, r) {
  if (r.has(e))
    return !0;
  for (const t of r)
    if (/^\d+$/.test(t) && e.startsWith(t + " -"))
      return !0;
  return !1;
}
function Q(e) {
  const r = Array.isArray(e) ? e : e ? [e] : [];
  return new Set(
    r.filter((t) => typeof t == "string").map((t) => t.trim()).filter(Boolean)
  );
}
function N(e) {
  return e.seksjonstype === "Kommune" || e.kommunal;
}
function ke(e, r, t, n) {
  if (r.type === "Kommune")
    return N(e);
  if (e.seksjonstype !== r.type)
    return !1;
  switch (r.type) {
    case "Plan":
      return !0;
    case "Delområdetype":
      return !!e.delområdetype && W(e.delområdetype, n);
    case "Delområdegruppe":
    case "Delområde":
    case "Område":
      return !!e.områdeId && t.has(e.områdeId);
  }
}
function Ke(e, r, t, n = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set()) {
  switch (r.type) {
    case "Kommune":
      return !1;
    case "Plan":
      return N(e);
    case "Delområdetype":
      return N(e) || e.seksjonstype === "Plan";
    case "Delområdegruppe":
      return N(e) || e.seksjonstype === "Plan" || e.seksjonstype === "Delområdetype" && !!e.delområdetype && W(e.delområdetype, t);
    case "Delområde":
      return N(e) || e.seksjonstype === "Plan" || e.seksjonstype === "Delområdetype" && !!e.delområdetype && W(e.delområdetype, t) || e.seksjonstype === "Delområdegruppe" && !!e.områdeId && o.has(e.områdeId);
    case "Område":
      return N(e) || e.seksjonstype === "Plan" || e.seksjonstype === "Område" || e.seksjonstype === "Delområdetype" && !!e.delområdetype && W(e.delområdetype, t) || e.seksjonstype === "Delområdegruppe" && !!e.områdeId && o.has(e.områdeId) || e.seksjonstype === "Delområde" && !!e.områdeId && n.has(e.områdeId);
  }
}
function yr(e, r, t, n) {
  return !ke(
    e,
    r,
    t,
    n
  );
}
function Be(e, r) {
  return r || !!e.parentGlobalId;
}
function Ir(e) {
  return !e;
}
function Me(e, r) {
  return e === "Kommune" || !r;
}
function fe(e) {
  return N(e) ? e.topp === !1 ? "bottom" : "top" : "middle";
}
const De = { top: 0, middle: 1, bottom: 2 };
function _e(e, r, t) {
  const n = De[fe(e)] - De[fe(r)];
  if (n !== 0)
    return n;
  if (t) {
    const o = t(e.planId) - t(r.planId);
    if (o !== 0)
      return o;
  }
  return (e.prioritet ?? 0) - (r.prioritet ?? 0);
}
function te(e) {
  return !!e.parentGlobalId && !e.overstyrer && !e.synlig;
}
function we(e) {
  const r = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Map();
  for (const o of e)
    o.globalId && t.set(o.globalId, o);
  const n = (o, s) => {
    if (s.has(o))
      return [];
    s.add(o);
    const d = t.get(o);
    return d?.parentGlobalId ? [d.parentGlobalId, ...n(d.parentGlobalId, s)] : [];
  };
  for (const o of e)
    if (o.overstyrer && o.globalId) {
      const s = n(o.globalId, /* @__PURE__ */ new Set());
      for (const d of s)
        r.add(d);
    }
  return r;
}
function Ue(e, r) {
  return e.filter((t) => !(t.globalId && r.has(t.globalId) || t.parentGlobalId && !t.overstyrer && !te(t)));
}
function Le(e, r, t = {}) {
  const n = Q(t.områdeIdCandidates), o = Q(t.delområdetypeCandidates), s = Q(t.ancestorDelområdeIds), d = Q(t.ancestorGruppeIds), a = (m) => ke(m, r, n, o), l = (m) => Ke(
    m,
    r,
    o,
    s,
    d
  ), i = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Set();
  for (const m of e)
    !m.parentGlobalId || !te(m) || (a(m) ? i.set(m.parentGlobalId, m.objectId) : l(m) && u.add(m.parentGlobalId));
  return e.filter((m) => !te(m)).map((m) => {
    const c = !a(m), p = !!(m.globalId && u.has(m.globalId)), y = m.globalId ? i.get(m.globalId) : void 0, g = !!m.parentGlobalId && m.overstyrer && a(m);
    return {
      ...m,
      isInherited: c,
      inheritedFrom: c ? m.seksjonstype : void 0,
      canToggleOverride: Be(m, c),
      canEdit: !c,
      canHide: p ? !1 : Me(m.seksjonstype, c),
      isHiddenAtThisLevel: y != null,
      isHiddenByAncestor: p,
      isOverriddenAtThisLevel: g,
      overrideObjectId: g ? m.objectId : void 0,
      hideObjectId: y
    };
  });
}
function Qe(e) {
  const r = [];
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    n.prioritet !== t && r.push({ objectId: n.objectId, prioritet: t });
  }
  return r;
}
function gr(e) {
  return e.length;
}
function z(e, r, t, n, o = 10) {
  const s = /* @__PURE__ */ new Map();
  for (const p of t)
    s.set(p.id, p);
  const d = We(n), a = Je(t), l = [], i = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), m = /* @__PURE__ */ new Set();
  let c = s.get(e);
  for (let p = 0; p < o && c && !(!c.parentType || !c.parentId); p++) {
    if (c.parentType === "Område") {
      l.push(c.parentId), c = s.get(c.parentId);
      continue;
    }
    if (c.parentType === "Delområdetype")
      i.add(c.parentId);
    else if (c.parentType === "Delområde") {
      u.add(c.parentId);
      const y = d.get(c.parentId);
      y?.delområdetype && i.add(y.delområdetype);
      const g = a.get(c.parentId);
      g && m.add(g);
    }
    break;
  }
  return {
    planId: r,
    delområdetyper: Array.from(i),
    delområdeIds: Array.from(u),
    ancestorOmrådeIds: l,
    gruppeIds: Array.from(m)
  };
}
function je(e, r, t, n) {
  const o = Je(t), s = We(n).get(e), d = /* @__PURE__ */ new Set();
  s?.delområdetype && d.add(s.delområdetype);
  const a = /* @__PURE__ */ new Set(), l = o.get(e);
  return l && a.add(l), {
    planId: r,
    delområdetyper: Array.from(d),
    delområdeIds: [],
    ancestorOmrådeIds: [],
    gruppeIds: Array.from(a)
  };
}
function We(e) {
  const r = /* @__PURE__ */ new Map();
  for (const t of e)
    for (const n of t.children ?? [])
      r.set(n.id, n);
  return r;
}
function Je(e) {
  const r = /* @__PURE__ */ new Map();
  for (const t of e) {
    if (t.kind !== "delomradegruppe-member" || !t.parentId || t.parentType !== "Område")
      continue;
    const n = t.code ?? t.navn;
    n && r.set(n, t.parentId);
  }
  return r;
}
function ze(e, r) {
  if (r.length === 0 || e.gruppeIds.length === 0)
    return e;
  const t = new Set(r);
  return {
    ...e,
    gruppeIds: e.gruppeIds.filter((n) => !t.has(n))
  };
}
function He(e, r) {
  const t = [];
  for (const s of e)
    for (const d of s)
      t.push(d);
  const n = we(t), o = /* @__PURE__ */ new Map();
  for (const s of e)
    for (const d of s)
      d.isHiddenAtThisLevel || d.isHiddenByAncestor || d.synlig && d.globalId && (n.has(d.globalId) || o.has(d.globalId) || o.set(d.globalId, d));
  return Array.from(o.values()).sort(
    (s, d) => _e(s, d, r)
  );
}
function Ve(e, r) {
  return e.filter(
    (t) => t.matrikkelenhetId == null || r != null && t.matrikkelenhetId === r
  );
}
function ye(e, r, t) {
  if (r.length === 0)
    return [...e];
  const n = (i) => `${i.omradetype}:${i.omradeId}`, o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
  for (const i of r) {
    const u = n({ omradeId: i.omradeId, omradetype: i.omradetype });
    i.operation === "remove" ? (o.add(u), s.delete(u)) : i.operation === "add" && !o.has(u) && s.add(u);
  }
  const d = e.filter((i) => !o.has(n(t.getKey(i)))), a = new Set(d.map((i) => n(t.getKey(i))));
  if (s.size === 0 || !t.addables)
    return d;
  const l = [];
  for (const i of t.addables) {
    const u = n(t.getKey(i));
    s.has(u) && !a.has(u) && (l.push(i), a.add(u));
  }
  return [...d, ...l];
}
const hr = {
  perMatrikkelenhet: /* @__PURE__ */ new Map(),
  utenMatrikkelenhet: []
};
function Ze(e, r, t) {
  if (r.length === 0)
    return e;
  const n = t === "kun-tillagte" ? /* @__PURE__ */ new Set() : new Set(e);
  for (const o of r)
    o.teigId !== void 0 && (o.operation === "add" ? n.add(o.teigId) : n.delete(o.teigId));
  return [...n];
}
function kr(e, r, t) {
  const n = (o) => {
    const s = r.perMatrikkelenhet.get(o.matrikkelenhetId);
    !s || s.length === 0 || (o.teigIds = [...Ze(o.teigIds ?? [], s, t)]);
  };
  n(e);
  for (const o of e.seksjoner ?? [])
    n(o);
}
function Xe(e) {
  const r = /* @__PURE__ */ new Map();
  for (const t of e) {
    const n = [t.omradeId, t.omradetype, t.teigId, t.matrikkelenhetId].map((s) => String(s)).join("|"), o = r.get(n) ?? [];
    o.push(t), r.set(n, o);
  }
  return [...r.values()].filter(
    (t) => t.some((n) => n.operation === "add") && t.some((n) => n.operation === "remove")
  );
}
const Wt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: P,
  AuthError: fr,
  ConfigurationError: C,
  NetworkError: k,
  OmrådeCycleError: pr,
  OmrådeNotFoundError: Ce,
  OverrideConflictError: cr,
  SeksjonError: R,
  SeksjonNotFoundError: oe,
  TOMT_DELTASETT: hr,
  ValidationError: q,
  anvendDeltaerPåEnhetstre: kr,
  anvendTeigDeltaer: Ze,
  applyPropertyOverrides: ye,
  belongsToAncestorContext: Ke,
  belongsToCurrentContext: ke,
  canEdit: Ir,
  canHide: Me,
  canToggleOverride: Be,
  compareSeksjonOrder: _e,
  computeOverriddenGlobalIds: we,
  enrichSections: Le,
  filterOverridden: Ue,
  finnBruddrader: Xe,
  getSectionPosition: fe,
  isHiddenMetadataSection: te,
  isInherited: yr,
  isKommunal: N,
  matchesDelområdetype: W,
  mergeUniqueByGlobalId: He,
  nextPriority: gr,
  normalizePriorities: Qe,
  resolveDelområdeAncestors: je,
  resolveOmrådeAncestors: z,
  scopeOverridesToMatrikkelenhet: Ve,
  stripRemovedGruppeIds: ze,
  toStringSet: Q
}, Symbol.toStringTag, { value: "Module" })), wr = [
  "Kommune",
  "Plan",
  "Delområdetype",
  "Delområdegruppe",
  "Delområde",
  "Område"
];
function Oe(e) {
  switch (e.type) {
    case "Kommune":
      return "Kommune";
    case "Plan":
      return `Plan:${e.planId}`;
    case "Delområdetype":
      return `Delområdetype:${e.planId}:${e.delområdetype}`;
    case "Delområdegruppe":
      return `Delområdegruppe:${e.planId}:${e.gruppeId}`;
    case "Delområde":
      return `Delområde:${e.planId}:${e.områdeId}:${e.delområdetype ?? ""}`;
    case "Område":
      return `Område:${e.planId}:${e.områdeId}`;
  }
}
const jr = ["p", "br", "b", "strong", "i", "em", "u", "ul", "ol", "li", "a", "span", "div"], br = ["href", "target", "rel"];
function vr(e) {
  return e ? sr.sanitize(e, {
    ALLOWED_TAGS: jr,
    ALLOWED_ATTR: br,
    ALLOW_DATA_ATTR: !1
  }) : "";
}
const ie = (e) => e === !0 || e === 1 || e === "1", Dr = (e) => {
  if (e === !0 || e === 1 || e === "1")
    return !0;
  if (e === !1 || e === 0 || e === "0")
    return !1;
}, Or = (e) => !(e === !1 || e === 0 || e === "0"), Sr = (e) => {
  if (e == null)
    return;
  const r = String(e).trim();
  if (r)
    return r.replace(/\.0+$/, "");
};
function le(e) {
  return {
    globalId: String(e.GlobalID ?? ""),
    objectId: Number(e.ObjectId ?? 0),
    planId: e.PlanId ?? void 0,
    områdeId: e.OmrådeId ?? void 0,
    id: e.Id ?? void 0,
    parentId: e.ParentId ?? void 0,
    parentGlobalId: e.ParentGlobalID ?? void 0,
    seksjonstype: e.Seksjonstype ?? "Plan",
    tittel: e.Tittel ?? "",
    tekst: e.Tekst ?? "",
    synlig: Or(e.Synlig),
    kommunal: ie(e.Kommunal),
    infoboks: ie(e.Infoboks),
    topp: Dr(e.Topp),
    delområdetype: e.Delområdetype ?? void 0,
    områdeNavn: e.OmrådeNavn ?? void 0,
    prioritet: Number(e.Prioritet ?? 0),
    overstyrer: ie(e.Overstyrer),
    kommunenummer: Sr(e.Kommunenummer)
  };
}
function Ye(e) {
  return {
    GlobalID: void 0,
    PlanId: e.planId,
    OmrådeId: e.områdeId,
    Id: e.id,
    ParentId: e.parentId,
    ParentGlobalID: e.parentGlobalId,
    Seksjonstype: e.seksjonstype,
    Tittel: e.tittel,
    // ArcGIS rejecter HTML utenfor sin allowlist (f.eks. inline `style`
    // med `font-family`/`letter-spacing` fra ekstern paste). Sanering skjer
    // her, ved kanten mot infrastructure, slik at både ny og legacy-data
    // ryddes før applyEdits.
    Tekst: vr(e.tekst),
    Synlig: e.synlig,
    Kommunal: e.kommunal,
    Infoboks: e.infoboks,
    Topp: e.topp,
    Delområdetype: e.delområdetype,
    OmrådeNavn: e.områdeNavn,
    Prioritet: e.prioritet,
    Overstyrer: e.overstyrer
  };
}
function Rr(e) {
  return {
    ...Ye(e),
    GlobalID: e.globalId,
    ObjectId: e.objectId
  };
}
function Fr(e) {
  if (!e.seksjonUrl)
    throw new C(
      "createArcgisSeksjonRepository: seksjonUrl required"
    );
  let r = null;
  const t = () => (r ?? (r = new ne({ url: e.seksjonUrl })), r), n = async (o, s) => {
    try {
      return await o();
    } catch (d) {
      throw d instanceof Error && d.name === "AbortError" ? new P() : new k(`${s} feilet: ${d?.message ?? d}`, d);
    }
  };
  return {
    async fetch(o, s) {
      return n(async () => {
        const d = t().createQuery();
        return d.where = o, d.outFields = ["*"], d.orderByFields = ["Prioritet"], (await t().queryFeatures(d, { signal: s?.signal })).features.map(
          (l) => le(l.attributes)
        );
      }, "fetch seksjoner");
    },
    async fetchByGlobalId(o, s) {
      return n(async () => {
        const d = o.replace(/'/g, "''"), a = t().createQuery();
        a.where = `GlobalID='${d}'`, a.outFields = ["*"];
        const l = await t().queryFeatures(a, { signal: s?.signal });
        return l.features.length === 0 ? null : le(l.features[0].attributes);
      }, "fetchByGlobalId");
    },
    async add(o) {
      return n(async () => {
        const s = new S({ attributes: Ye(o) }), a = (await t().applyEdits({ addFeatures: [s] }))?.addFeatureResults?.[0];
        if (a?.error)
          throw new k(
            `Opprettelse feilet: ${a.error.message ?? ""}`,
            a.error
          );
        const l = a?.objectId;
        if (l == null)
          throw new k("Opprettelse feilet: mangler objectId i respons");
        const i = t().createQuery();
        i.where = `ObjectId=${l}`, i.outFields = ["*"];
        const m = (await t().queryFeatures(i)).features[0];
        if (!m)
          throw new k(
            "Opprettelse feilet: klarte ikke lese tilbake ny rad"
          );
        return le(m.attributes);
      }, "add seksjon");
    },
    async update(o) {
      return n(async () => {
        if (!o.globalId)
          throw new k("update: globalId mangler");
        const d = { updateFeatures: [new S({ attributes: Rr(o) })], useGlobalIds: !0 }, l = (await t().applyEdits(
          d
        ))?.updateFeatureResults?.[0];
        if (l?.error)
          throw new k(
            `Lagring feilet: ${l.error.message ?? ""}`,
            l.error
          );
        return o;
      }, "update seksjon");
    },
    async delete(o) {
      await n(
        () => t().applyEdits({
          deleteFeatures: [{ objectId: o }]
        }),
        "delete seksjon"
      );
    },
    async reorder(o) {
      o.length !== 0 && await n(async () => {
        const s = o.map((u) => u.objectId), d = t().createQuery();
        d.where = `ObjectId IN (${s.join(",")})`, d.outFields = ["*"];
        const a = await t().queryFeatures(d), l = new Map(o.map((u) => [u.objectId, u.prioritet])), i = a.features.map((u) => {
          const m = u.attributes.ObjectId;
          if (m == null)
            return null;
          const c = l.get(m);
          return c == null ? null : new S({
            attributes: { ...u.attributes, Prioritet: c }
          });
        }).filter((u) => u !== null);
        i.length !== 0 && await t().applyEdits({ updateFeatures: i });
      }, "reorder seksjoner");
    }
  };
}
async function Jt(e, r, t) {
  const n = await e.fetchByGlobalId(r, t);
  if (!n)
    throw new oe(r);
  return n;
}
const Se = {
  minRatio: 0.01,
  minAreaM2: 1 / 0
};
function ue(e) {
  try {
    return Math.abs(dr.execute(e, { unit: "square-meters" }));
  } catch {
    return 0;
  }
}
function Er(e, r, t = {}) {
  if (!e || !r)
    return { keep: !0, reason: "missing-geometry" };
  const n = t.minAreaM2 ?? Se.minAreaM2, o = t.minRatio ?? Se.minRatio, s = e.spatialReference?.wkid, d = r.spatialReference?.wkid;
  if (s != null && d != null && s !== d)
    return { keep: !0, reason: "sr-mismatch", srcWkid: s, candWkid: d };
  const a = e, l = r;
  try {
    if (!ir.execute(a, l))
      return { keep: !1, reason: "no-intersect", srcWkid: s, candWkid: d };
  } catch {
    return { keep: !0, reason: "intersect-error", srcWkid: s, candWkid: d };
  }
  let i;
  try {
    i = ar.execute(a, l);
  } catch {
    return { keep: !0, reason: "intersection-error", srcWkid: s, candWkid: d };
  }
  if (!i)
    return s != null && d != null && s === d ? { keep: !1, reason: "touch-no-area", srcWkid: s, candWkid: d, overlapAreaM2: 0, ratio: 0 } : { keep: !0, reason: "intersection-null", srcWkid: s, candWkid: d };
  const u = ue(i), m = ue(e), c = ue(r), p = Math.min(m, c), y = p > 0 ? u / p : 0, g = { srcWkid: s, candWkid: d, overlapAreaM2: u, sourceAreaM2: m, candidateAreaM2: c, ratio: y };
  return y >= o ? { keep: !0, reason: "ratio-pass", ...g } : u >= n ? { keep: !0, reason: "area-pass", ...g } : { keep: !1, reason: "below-threshold", ...g };
}
function Ar(e, r, t = {}) {
  return Er(e, r, t).keep;
}
function $r(e) {
  return e.split("'").join("''");
}
function h(e) {
  return `'${$r(e)}'`;
}
function M(e, r) {
  const t = Array.from(
    new Set(r.filter(Boolean).map((n) => n.trim()).filter(Boolean))
  );
  return t.length === 0 ? "" : t.length === 1 ? `${e}=${h(t[0])}` : `${e} IN (${t.map(h).join(", ")})`;
}
const xe = "​", er = "‌", Nr = [
  "Plan",
  "Delområdetype",
  "Delområdegruppe",
  "Delområde",
  "Område"
];
function Pr(e) {
  const r = typeof e == "string" ? e : "";
  if (r.startsWith(xe))
    return { kind: "delomradegruppe", navn: r.slice(1) };
  if (r.startsWith(er)) {
    const t = r.slice(1);
    return { kind: "delomradegruppe-member", navn: t, code: t };
  }
  return { kind: "egendefinert", navn: r };
}
function J(e) {
  return e.kind === "delomradegruppe" ? xe + e.navn : e.kind === "delomradegruppe-member" ? er + (e.code ?? e.navn) : e.navn;
}
function Tr(e, r) {
  if (r == null || r === "")
    return {};
  const t = String(r), n = typeof e == "string" ? e : "", o = Nr.find((s) => s === n);
  return o ? { parentType: o, parentId: t } : { parentId: t };
}
function X(e, r) {
  const t = e.ObjectId ?? e.OBJECTID, n = String(e.Id ?? t ?? ""), { parentType: o, parentId: s } = Tr(e.ParentType, e.ParentRef), d = Pr(e.Navn);
  return {
    id: n,
    objectId: t,
    kind: d.kind,
    navn: d.navn || `Område ${t ?? ""}`,
    planId: e.PlanId ?? "",
    parentType: o,
    parentId: s,
    code: d.code,
    geometry: r
  };
}
const me = Ge("seksjon:arcgisOmrådeRepository");
function qr(e, r, t) {
  const n = e;
  if (!n?.features)
    return e;
  const o = n.spatialReference?.wkid ?? t, s = n.features.filter((d) => {
    if (!d.geometry)
      return !0;
    let a;
    try {
      a = Te.fromJSON(d.geometry);
    } catch {
      return !0;
    }
    return o != null && (a.spatialReference = new qe({ wkid: o })), Ar(r, a);
  });
  return { ...n, features: s };
}
function Gr(e) {
  const r = e.features ?? [], t = [
    "plan",
    "delomrade",
    "delomradegruppe",
    "egendefinert"
  ], n = [];
  for (const o of r) {
    const s = o.attributes ?? {}, d = s.omradeId == null ? "" : String(s.omradeId), a = s.omradetype, l = s.operation;
    if (!d || !a || !t.includes(a) || l !== "add" && l !== "remove")
      continue;
    const i = s.matrikkelenhetId, u = i == null || i === "" ? void 0 : Number(i);
    n.push({
      omradeId: d,
      omradetype: a,
      operation: l,
      ...u != null && Number.isFinite(u) ? { matrikkelenhetId: u } : {}
    });
  }
  return n;
}
function Cr(e) {
  if (!e.områderUrl)
    throw new C(
      "createArcgisOmrådeRepository: områderUrl required"
    );
  let r = null;
  const t = () => (r ?? (r = new ne({ url: e.områderUrl })), r), n = async (i, u) => {
    try {
      return await i();
    } catch (m) {
      throw m instanceof Error && m.name === "AbortError" ? new P() : new k(`${u} feilet: ${m?.message ?? m}`, m);
    }
  }, o = async (i) => {
    const u = t().createQuery();
    u.where = "1=1", u.outStatistics = [
      {
        statisticType: "max",
        onStatisticField: "Id",
        outStatisticFieldName: "MaxId"
      }
    ];
    const c = (await t().queryFeatures(u)).features[0]?.attributes?.MaxId, p = typeof c == "number" && Number.isFinite(c) ? c : 0;
    return Math.max(p, i) + 1;
  }, s = Gr, d = async (i, u) => {
    if (!e.eiendommerUrl)
      return [];
    const c = `${e.eiendommerUrl.replace(/\/$/, "")}/query`, p = i.toJSON?.() ?? i, y = i.spatialReference?.wkid;
    try {
      const g = await F(c, {
        method: "post",
        query: {
          f: "json",
          geometry: JSON.stringify(p),
          geometryType: "esriGeometryPolygon",
          // outSR = inSR slik at returnert geometri ligger i samme SR som
          // kilden og kan sammenlignes direkte av areal-filteret under.
          ...y != null ? { inSR: y, outSR: y } : {},
          spatialRel: "esriSpatialRelIntersects",
          where: "omradetype IN ('plan', 'delomrade', 'delomradegruppe', 'egendefinert') AND operation IN ('add', 'remove')",
          outFields: "omradeId,omradetype,operation,matrikkelenhetId",
          returnGeometry: !0
        },
        signal: u?.signal
      }), f = qr(
        g.data,
        i,
        y
      );
      return s(f);
    } catch (g) {
      if (g instanceof Error && g.name === "AbortError")
        throw new P();
      return me.warn("findOverridesByGeometry feilet:", g), [];
    }
  }, a = async (i, u) => {
    const m = [...new Set(i)].map((c) => Number(c)).filter((c) => Number.isFinite(c));
    return m.length === 0 ? [] : n(async () => {
      const c = t().createQuery();
      return c.where = `Id IN (${m.join(",")})`, c.outFields = ["*"], c.returnGeometry = !1, (await t().queryFeatures(c, {
        signal: u?.signal
      })).features.map(
        (y) => X(y.attributes)
      );
    }, "fetchOmrådeByIds");
  }, l = async (i) => {
    if (!e.eiendommerUrl)
      return;
    const u = e.eiendommerUrl.replace(/\/$/, ""), m = `${u}/query`, c = `omradeid = ${i} AND (omradetype = 'egendefinert' OR omradetype IS NULL)`, y = (await F(m, {
      method: "post",
      query: { f: "json", where: c, returnIdsOnly: !0 }
    })).data.objectIds ?? [];
    if (y.length === 0)
      return;
    const g = `${u}/applyEdits`;
    await F(g, {
      method: "post",
      query: { f: "json", deletes: y.join(",") }
    });
  };
  return {
    async fetchEgendefinerteForPlan(i, u) {
      return n(async () => {
        const m = t().createQuery();
        return m.where = `PlanId=${h(i)} AND ParentRef IS NOT NULL AND ParentRef <> ''`, m.outFields = ["*"], (await t().queryFeatures(m, {
          signal: u?.signal
        })).features.map(
          (p) => X(p.attributes)
        );
      }, "fetch egendefinerte områder");
    },
    async findOverlappingGeometry(i, u, m) {
      return n(async () => {
        const c = t().createQuery();
        return c.geometry = i, c.spatialRelationship = "intersects", c.outFields = ["*"], c.returnGeometry = !0, u && (c.where = `PlanId=${h(u)}`), (await t().queryFeatures(c, {
          signal: m?.signal
        })).features.map(
          (y) => X(
            y.attributes,
            y.geometry
          )
        );
      }, "findOverlappingGeometry");
    },
    async resolveAncestry(i, u, m) {
      const c = t().createQuery();
      c.where = `PlanId=${h(u)} AND ParentRef IS NOT NULL AND ParentRef <> ''`, c.outFields = ["*"];
      const y = (await t().queryFeatures(c, {
        signal: m?.signal
      })).features.map(
        (g) => X(g.attributes)
      );
      return z(i, u, y, []);
    },
    async findOverridesForTeig(i, u, m) {
      if (!e.eiendommerUrl || !Number.isFinite(i))
        return [];
      const p = `${e.eiendommerUrl.replace(/\/$/, "")}/query`;
      try {
        const y = await F(p, {
          method: "post",
          query: {
            f: "json",
            where: `teigId = ${i}`,
            outFields: "omradeId,omradetype,operation,matrikkelenhetId",
            returnGeometry: !1
          },
          signal: m?.signal
        });
        return s(y.data);
      } catch (y) {
        if (y instanceof Error && y.name === "AbortError")
          throw new P();
        return me.warn("findOverridesForTeig feilet:", y), [];
      }
    },
    findOverridesByGeometry: d,
    fetchOmrådeByIds: a,
    async findEgendefinerteByGeometry(i, u) {
      const c = (await d(i, u)).filter((p) => p.omradetype === "egendefinert" && p.operation === "add").map((p) => p.omradeId);
      return c.length === 0 ? [] : a(c, u);
    },
    async add(i) {
      return n(async () => {
        const u = i.kind ?? "egendefinert", m = J({
          kind: u,
          navn: i.navn,
          code: i.code
        }), c = new S({
          attributes: {
            Navn: m,
            PlanId: i.planId,
            ...i.parentType ? { ParentType: i.parentType } : {},
            ...i.parentId ? { ParentRef: i.parentId } : {}
          }
        }), y = (await t().applyEdits({
          addFeatures: [c]
        })).addFeatureResults?.[0];
        if (!y || y.error)
          throw new k(
            y?.error?.message ?? "Failed to add område",
            y?.error
          );
        const g = y.objectId, f = await o(g), O = new S({
          attributes: { ObjectId: g, Id: f }
        }), E = (await t().applyEdits({
          updateFeatures: [O]
        })).updateFeatureResults?.[0];
        if (E?.error)
          throw new k(
            E.error.message ?? "Failed to initialize område Id",
            E.error
          );
        return {
          id: String(f),
          objectId: g,
          kind: u,
          navn: i.navn,
          planId: i.planId,
          parentType: i.parentType,
          parentId: i.parentId,
          code: i.code
        };
      }, "add område");
    },
    async update(i) {
      return n(async () => {
        const u = { ObjectId: i.objectId };
        if ("navn" in i) {
          const y = i.kind ?? "egendefinert";
          u.Navn = J({
            kind: y,
            navn: i.navn ?? "",
            code: i.code
          });
        }
        "parentType" in i && (u.ParentType = i.parentType), "parentId" in i && (u.ParentRef = i.parentId);
        const m = new S({ attributes: u }), p = (await t().applyEdits({
          updateFeatures: [m]
        })).updateFeatureResults?.[0];
        if (p?.error)
          throw new k(
            p.error.message ?? "Failed to update område",
            p.error
          );
        return {
          id: i.id ?? "",
          objectId: i.objectId,
          kind: i.kind ?? "egendefinert",
          navn: i.navn ?? "",
          planId: i.planId ?? "",
          parentType: i.parentType,
          parentId: i.parentId
        };
      }, "update område");
    },
    async delete(i, u) {
      await n(async () => {
        const m = Number(u);
        if (Number.isFinite(m))
          try {
            await l(m);
          } catch (y) {
            me.warn("Kunne ikke rydde opp eiendommer-deltaer:", y);
          }
        const p = (await t().applyEdits({
          deleteFeatures: [{ objectId: i }]
        })).deleteFeatureResults?.[0];
        if (p?.error)
          throw new k(
            p.error.message ?? "Failed to delete område",
            p.error
          );
      }, "delete område");
    }
  };
}
function Re(e) {
  return {
    objectId: Number(e.OBJECTID ?? 0),
    seksjonsGlobalId: String(e.SeksjonsGlobalID ?? ""),
    filId: e.FilId ?? void 0,
    tittel: e.Tittel ?? void 0,
    beskrivelse: e.Beskrivelse ?? void 0,
    prioritet: Number(e.Prioritet ?? 0)
  };
}
function Kr(e) {
  return {
    SeksjonsGlobalID: e.seksjonsGlobalId,
    FilId: e.filId,
    Tittel: e.tittel,
    Beskrivelse: e.beskrivelse,
    Prioritet: e.prioritet
  };
}
function Br(e) {
  if (!e.seksjonelementUrl)
    throw new C(
      "createArcgisSeksjonelementRepository: seksjonelementUrl required"
    );
  let r = null;
  const t = async () => (r || (r = new ne({
    url: e.seksjonelementUrl,
    refreshInterval: 0
  }), await r.load()), r), n = async (o, s) => {
    try {
      return await o();
    } catch (d) {
      throw d instanceof Error && d.name === "AbortError" ? new P() : new k(`${s} feilet: ${d?.message ?? d}`, d);
    }
  };
  return {
    async fetchForSection(o, s) {
      return n(async () => {
        const d = await t(), a = d.createQuery();
        return a.where = `SeksjonsGlobalID = ${h(o)}`, a.outFields = ["*"], a.returnGeometry = !1, a.orderByFields = ["Prioritet"], (await d.queryFeatures(a, { signal: s?.signal })).features.map((i) => ({
          ...Re(i.attributes),
          objectId: Number(i.getObjectId())
        }));
      }, "fetchForSection");
    },
    async add(o) {
      return n(async () => {
        const s = await t(), d = new S({
          attributes: Kr(o)
        }), l = (await s.applyEdits({ addFeatures: [d] })).addFeatureResults?.[0];
        if (!l || l.error)
          throw new k(
            l?.error?.message ?? "Failed to add element",
            l?.error
          );
        const i = s.createQuery();
        i.where = `OBJECTID = ${l.objectId}`, i.outFields = ["*"], i.returnGeometry = !1;
        const m = (await s.queryFeatures(i)).features[0];
        if (!m)
          throw new k(
            `Element med objectId ${l.objectId} ikke funnet etter insertion`
          );
        return {
          ...Re(m.attributes),
          objectId: Number(m.getObjectId())
        };
      }, "add element");
    },
    async update(o, s) {
      await n(async () => {
        const d = await t(), a = new S({
          attributes: {
            OBJECTID: o,
            Tittel: s.tittel,
            Beskrivelse: s.beskrivelse
          }
        }), i = (await d.applyEdits({ updateFeatures: [a] })).updateFeatureResults?.[0];
        if (i?.error)
          throw new k(
            i.error.message ?? "Failed to update element",
            i.error
          );
      }, "update element");
    },
    async delete(o) {
      await n(async () => {
        const s = await t(), a = (await s.applyEdits({
          deleteFeatures: [new S({ attributes: { [s.objectIdField]: o } })]
        })).deleteFeatureResults?.[0];
        if (a?.error)
          throw new k(
            a.error.message ?? "Failed to delete element",
            a.error
          );
      }, "delete element");
    },
    async reorder(o) {
      o.length !== 0 && await n(async () => {
        const s = await t(), d = o.map(
          (i) => new S({
            attributes: {
              OBJECTID: i.objectId,
              Prioritet: i.prioritet
            }
          })
        ), l = ((await s.applyEdits({ updateFeatures: d })).updateFeatureResults ?? []).filter((i) => i.error);
        if (l.length > 0)
          throw new k(
            `Failed to reorder elements: ${l.map((i) => i.error?.message).join(", ")}`
          );
      }, "reorder elements");
    }
  };
}
const Fe = "​", Y = "‌";
function Mr(e) {
  if (!e.områderUrl)
    throw new C(
      "createArcgisDelområdegruppeRepository: områderUrl required"
    );
  let r = null;
  const t = () => (r ?? (r = new ne({ url: e.områderUrl })), r), n = async (o, s) => {
    try {
      return await o();
    } catch (d) {
      throw d instanceof Error && d.name === "AbortError" ? new P() : new k(`${s} feilet: ${d?.message ?? d}`, d);
    }
  };
  return {
    async fetchForPlan(o, s) {
      return n(async () => {
        const d = t().createQuery();
        d.where = `PlanId=${h(o)} AND Navn LIKE '${Fe}%'`, d.outFields = ["*"];
        const a = await t().queryFeatures(d, {
          signal: s?.signal
        }), l = [];
        for (const i of a.features) {
          const u = i.attributes, m = u.ObjectId ?? u.OBJECTID, c = String(u.Id ?? m), p = typeof u.Navn == "string" ? u.Navn : "", y = p.startsWith(Fe) ? p.slice(1) : p;
          if (!m)
            continue;
          const g = t().createQuery();
          g.where = `PlanId=${h(o)} AND ParentRef=${h(c)} AND Navn LIKE '${Y}%'`, g.outFields = ["*"];
          const O = (await t().queryFeatures(g, {
            signal: s?.signal
          })).features.map((V) => {
            const E = V.attributes, Z = typeof E.Navn == "string" ? E.Navn : "";
            return Z.startsWith(Y) ? Z.slice(1) : "";
          }).filter(Boolean);
          l.push({
            id: c,
            objectId: m,
            planId: o,
            delområdetype: "",
            navn: y,
            medlemmer: O
          });
        }
        return l;
      }, "fetchForPlan delområdegrupper");
    },
    async create(o) {
      return n(async () => {
        const s = J({
          kind: "delomradegruppe",
          navn: o.navn
        }), d = new S({
          attributes: {
            Navn: s,
            PlanId: o.planId,
            ParentType: "Delområdetype",
            ParentRef: o.delområdetype
          }
        }), l = (await t().applyEdits({
          addFeatures: [d]
        })).addFeatureResults?.[0];
        if (!l || l.error)
          throw new k(
            l?.error?.message ?? "Failed to create delområdegruppe",
            l?.error
          );
        const i = l.objectId;
        return o.medlemmer && o.medlemmer.length > 0 && await this.addMembers({
          gruppeId: String(i),
          planId: o.planId,
          medlemmer: o.medlemmer
        }), {
          id: String(i),
          objectId: i,
          planId: o.planId,
          delområdetype: o.delområdetype,
          navn: o.navn,
          medlemmer: o.medlemmer ?? []
        };
      }, "create delområdegruppe");
    },
    async addMembers({ gruppeId: o, planId: s, medlemmer: d }) {
      d.length !== 0 && await n(async () => {
        const a = d.map(
          (u) => new S({
            attributes: {
              Navn: J({
                kind: "delomradegruppe-member",
                navn: u,
                code: u
              }),
              PlanId: s,
              ParentType: "Område",
              ParentRef: o
            }
          })
        ), i = ((await t().applyEdits({
          addFeatures: a
        })).addFeatureResults ?? []).filter((u) => u.error);
        if (i.length > 0)
          throw new k(
            `Failed to add ${i.length} members: ${i.map((u) => u.error?.message).join(", ")}`
          );
      }, "addMembers");
    },
    async removeMembers({ gruppeId: o, planId: s, medlemmer: d }) {
      d.length !== 0 && await n(async () => {
        const a = d.map(
          (p) => `Navn=${h(Y + p)}`
        ).join(" OR "), l = t().createQuery();
        l.where = `PlanId=${h(s)} AND ParentRef=${h(o)} AND (${a})`, l.outFields = ["OBJECTID"];
        const u = (await t().queryFeatures(l)).features.map((p) => p.attributes.OBJECTID).filter((p) => p != null);
        if (u.length === 0)
          return;
        const c = ((await t().applyEdits({
          deleteFeatures: u.map(
            (p) => ({ objectId: p })
          )
        })).deleteFeatureResults ?? []).filter((p) => p.error);
        if (c.length > 0)
          throw new k(
            `Failed to remove ${c.length} members`,
            c
          );
      }, "removeMembers");
    },
    async rename({ gruppeObjectId: o, navn: s }) {
      await n(async () => {
        const d = new S({
          attributes: {
            OBJECTID: o,
            Navn: J({ kind: "delomradegruppe", navn: s })
          }
        }), l = (await t().applyEdits({
          updateFeatures: [d]
        })).updateFeatureResults?.[0];
        if (l?.error)
          throw new k(
            l.error.message ?? "Failed to rename delområdegruppe",
            l.error
          );
      }, "rename delområdegruppe");
    },
    async delete({ gruppeObjectId: o, gruppeId: s }) {
      await n(async () => {
        const d = t().createQuery();
        d.where = `ParentRef=${h(s)} AND Navn LIKE '${Y}%'`, d.outFields = ["OBJECTID"];
        const l = (await t().queryFeatures(d)).features.map((m) => m.attributes.OBJECTID).filter((m) => m != null);
        l.length > 0 && await t().applyEdits({
          deleteFeatures: l.map(
            (m) => ({ objectId: m })
          )
        });
        const u = (await t().applyEdits({
          deleteFeatures: [
            { objectId: o }
          ]
        })).deleteFeatureResults?.[0];
        if (u?.error)
          throw new k(
            u.error.message ?? "Failed to delete delområdegruppe",
            u.error
          );
      }, "delete delområdegruppe");
    }
  };
}
function zt(e) {
  if (!e.seksjonUrl)
    throw new C("createSeksjonClient: seksjonUrl required");
  const r = Fr({ seksjonUrl: e.seksjonUrl }), t = e.områderUrl ? Cr({
    områderUrl: e.områderUrl,
    eiendommerUrl: e.eiendommerUrl
  }) : void 0, n = e.seksjonelementUrl ? Br({
    seksjonelementUrl: e.seksjonelementUrl
  }) : void 0, o = e.områderUrl ? Mr({ områderUrl: e.områderUrl }) : void 0;
  return { seksjoner: r, områder: t, elementer: n, delområdegrupper: o };
}
const I = {
  all: ["seksjon"],
  seksjoner: {
    all: ["seksjon", "seksjoner"],
    forContext: (e, r = "filtered") => r === "filtered" ? ["seksjon", "seksjoner", Oe(e)] : ["seksjon", "seksjoner", Oe(e), "raw"],
    byGlobalId: (e) => ["seksjon", "seksjon", e]
  },
  elementer: {
    all: ["seksjon", "elementer"],
    forSeksjon: (e) => ["seksjon", "elementer", e]
  },
  områder: {
    all: ["seksjon", "områder"],
    forPlan: (e) => ["seksjon", "områder", e],
    ancestry: (e, r) => ["seksjon", "områder", "ancestry", e, r]
  },
  delområdegrupper: {
    all: ["seksjon", "delområdegrupper"],
    forPlan: (e) => ["seksjon", "delområdegrupper", e]
  }
};
function _r(e, r = {}) {
  const t = [];
  switch (t.push(Ur()), e.type) {
    case "Kommune":
      break;
    case "Plan":
      t.push(`(PlanId=${h(e.planId)} AND Seksjonstype='Plan')`);
      break;
    case "Delområdetype":
      t.push(`(PlanId=${h(e.planId)} AND Seksjonstype='Plan')`), t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdetype' AND ${x(
          [e.delområdetype, ...r.delområdetypeCandidates ?? []]
        )})`
      );
      break;
    case "Delområdegruppe": {
      t.push(`(PlanId=${h(e.planId)} AND Seksjonstype='Plan')`);
      const n = [
        e.delområdetype,
        ...r.delområdetypeCandidates ?? []
      ], o = x(n);
      o && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdetype' AND ${o})`
      ), t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdegruppe' AND OmrådeId=${h(e.gruppeId)})`
      );
      break;
    }
    case "Delområde": {
      t.push(`(PlanId=${h(e.planId)} AND Seksjonstype='Plan')`);
      const n = [
        ...e.delområdetype ? [e.delområdetype] : [],
        ...r.delområdetypeCandidates ?? []
      ], o = x(n);
      o && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdetype' AND ${o})`
      );
      const s = M("OmrådeId", r.ancestry?.gruppeIds ?? []);
      s && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdegruppe' AND ${s})`
      );
      const d = [e.områdeId, ...r.områdeIdCandidates ?? []], a = M("OmrådeId", d);
      a && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområde' AND ${a})`
      );
      break;
    }
    case "Område": {
      t.push(`(PlanId=${h(e.planId)} AND Seksjonstype='Plan')`);
      const n = [
        ...r.delområdetypeCandidates ?? [],
        ...r.ancestry?.delområdetyper ?? []
      ], o = x(n);
      o && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdetype' AND ${o})`
      );
      const s = M(
        "OmrådeId",
        r.ancestry?.gruppeIds ?? []
      );
      s && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdegruppe' AND ${s})`
      );
      const d = M(
        "OmrådeId",
        r.ancestry?.delområdeIds ?? []
      );
      d && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområde' AND ${d})`
      );
      const a = [
        e.områdeId,
        ...r.ancestry?.ancestorOmrådeIds ?? [],
        ...r.områdeIdCandidates ?? []
      ], l = M("OmrådeId", a);
      l && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Område' AND ${l})`
      );
      break;
    }
  }
  return t.join(" OR ");
}
function Ur() {
  return "(Seksjonstype='Kommune' OR Kommunal=1)";
}
function x(e) {
  const r = Array.from(
    new Set(e.filter(Boolean).map((n) => n.trim()).filter(Boolean))
  );
  if (r.length === 0)
    return "";
  const t = r.map((n) => /^\d+$/.test(n) ? `(Delområdetype=${h(n)} OR Delområdetype LIKE ${h(n + " -%")})` : `Delområdetype=${h(n)}`);
  return t.length === 1 ? t[0] : `(${t.join(" OR ")})`;
}
async function re({ seksjonRepo: e, områdeRepo: r }, {
  context: t,
  ancestry: n,
  områdeIdCandidates: o,
  delområdetypeCandidates: s,
  includeOverriddenAncestors: d,
  synligOnly: a
}, l) {
  const i = await Lr(
    t,
    n,
    r,
    l
  ), u = _r(t, {
    ancestry: i,
    områdeIdCandidates: o,
    delområdetypeCandidates: s
  }), m = await e.fetch(u, l), c = d ? m : Ue(m, we(m)), p = [], y = [];
  t.type === "Delområdetype" ? (y.push(t.delområdetype), s && y.push(...s)) : t.type === "Delområdegruppe" ? (p.push(t.gruppeId), y.push(t.delområdetype), s && y.push(...s)) : (t.type === "Delområde" || t.type === "Område") && (p.push(t.områdeId), o && p.push(...o), t.type === "Delområde" && t.delområdetype && y.push(t.delområdetype));
  const g = Le(c, t, {
    områdeIdCandidates: p,
    delområdetypeCandidates: y,
    ancestorDelområdeIds: i?.delområdeIds,
    ancestorGruppeIds: i?.gruppeIds
  });
  return a ? g.filter((f) => f.synlig) : g;
}
async function Lr(e, r, t, n) {
  if (r)
    return r;
  if (t) {
    if (e.type === "Område")
      return t.resolveAncestry(e.områdeId, e.planId, n);
    if (e.type === "Delområde") {
      const o = await t.fetchEgendefinerteForPlan(e.planId, n);
      return je(e.områdeId, e.planId, o, []);
    }
  }
}
const Qr = j.object({
  planId: j.string().trim().optional(),
  områdeId: j.string().trim().optional(),
  id: j.string().trim().optional(),
  parentId: j.string().trim().optional(),
  parentGlobalId: j.string().trim().optional(),
  seksjonstype: j.enum(
    wr
  ),
  tittel: j.string().trim().min(1, "Tittel kreves").max(200, "Tittel maks 200 tegn"),
  tekst: j.string().max(2e4, "Tekst er for lang"),
  synlig: j.boolean().default(!0),
  kommunal: j.boolean().default(!1),
  infoboks: j.boolean().default(!1),
  topp: j.boolean().optional(),
  delområdetype: j.string().optional(),
  områdeNavn: j.string().optional(),
  prioritet: j.number().int().nonnegative(),
  overstyrer: j.boolean().default(!1)
}), Ht = j.object({
  tittel: j.string().trim().min(1, "Tittel kreves").max(200),
  tekst: j.string().max(2e4),
  topp: j.boolean().optional(),
  infoboks: j.boolean().default(!1)
});
async function Wr({ seksjonRepo: e }, { values: r, editing: t }) {
  if (t)
    return e.update({
      ...t,
      ...r
    });
  const n = Qr.safeParse(r);
  if (!n.success) {
    const o = {};
    for (const s of n.error.issues) {
      const d = s.path.join(".");
      d && (o[d] = s.message);
    }
    throw new q("Ugyldig seksjonsinput", o);
  }
  return e.add(r);
}
async function Jr({ seksjonRepo: e }, r) {
  await e.delete(r.objectId);
}
async function zr({ seksjonRepo: e, elementRepo: r }, { sourceGlobalId: t, enable: n, context: o }, s) {
  const d = await e.fetchByGlobalId(t, s);
  if (!d)
    throw new oe(t);
  const a = Hr(d, o);
  if (d.parentGlobalId && a) {
    if (d.overstyrer === n)
      return { action: "already-in-state", section: d };
    const m = await e.update({ ...d, overstyrer: n });
    return {
      action: n ? "activated-existing" : "deactivated",
      section: m
    };
  }
  if (!n)
    return { action: "already-in-state", section: d };
  const l = await Vr(
    e,
    t,
    o,
    s
  );
  if (l)
    return { action: "activated-existing", section: await e.update({ ...l, overstyrer: !0 }) };
  const i = Zr(o), u = await e.add({
    ...d,
    seksjonstype: i,
    planId: Xr(o) ?? d.planId,
    områdeId: Yr(o) ?? d.områdeId,
    delområdetype: o.type === "Delområdetype" || o.type === "Delområdegruppe" || o.type === "Delområde" ? o.delområdetype : d.delområdetype,
    parentGlobalId: d.globalId,
    parentId: d.id,
    overstyrer: !0,
    synlig: !0
    // ObjectId/GlobalID are system-assigned.
  });
  if (r && d.globalId && u.globalId) {
    const m = await r.fetchForSection(d.globalId, s);
    for (const c of m)
      await r.add({
        seksjonsGlobalId: u.globalId,
        filId: c.filId,
        tittel: c.tittel,
        beskrivelse: c.beskrivelse,
        prioritet: c.prioritet
      });
  }
  return { action: "created", section: u };
}
function Hr(e, r) {
  switch (r.type) {
    case "Kommune":
      return e.seksjonstype === "Kommune" || e.kommunal;
    case "Plan":
      return e.seksjonstype === "Plan" && e.planId === r.planId;
    case "Delområdetype":
      return e.seksjonstype === "Delområdetype" && e.planId === r.planId && e.delområdetype === r.delområdetype;
    case "Delområdegruppe":
      return e.seksjonstype === "Delområdegruppe" && e.planId === r.planId && e.områdeId === r.gruppeId && e.delområdetype === r.delområdetype;
    case "Delområde":
      return e.seksjonstype === "Delområde" && e.planId === r.planId && e.områdeId === r.områdeId;
    case "Område":
      return e.seksjonstype === "Område" && e.planId === r.planId && e.områdeId === r.områdeId;
  }
}
async function Vr(e, r, t, n) {
  const s = [`ParentGlobalID='${r.split("'").join("''")}'`, "Overstyrer=0"];
  return (t.type === "Plan" || t.type === "Delområdetype" || t.type === "Delområdegruppe" || t.type === "Delområde" || t.type === "Område") && s.push(`PlanId='${t.planId.split("'").join("''")}'`), (t.type === "Delområdetype" || t.type === "Delområdegruppe") && s.push(`Delområdetype='${t.delområdetype.split("'").join("''")}'`), t.type === "Delområdegruppe" && s.push(`OmrådeId='${t.gruppeId.split("'").join("''")}'`), (t.type === "Delområde" || t.type === "Område") && s.push(`OmrådeId='${t.områdeId.split("'").join("''")}'`), (await e.fetch(s.join(" AND "), n))[0] ?? null;
}
function Zr(e) {
  switch (e.type) {
    case "Kommune":
      return "Kommune";
    case "Plan":
      return "Plan";
    case "Delområdetype":
      return "Delområdetype";
    case "Delområdegruppe":
      return "Delområdegruppe";
    case "Delområde":
      return "Delområde";
    case "Område":
      return "Område";
  }
}
function Xr(e) {
  return e.type === "Kommune" ? void 0 : e.planId;
}
function Yr(e) {
  if (e.type === "Delområdegruppe")
    return e.gruppeId;
  if (e.type === "Delområde" || e.type === "Område")
    return e.områdeId;
}
function xr(e) {
  switch (e.type) {
    case "Kommune":
      return { seksjonstype: "Kommune", planId: void 0, områdeId: void 0, delområdetype: void 0 };
    case "Plan":
      return { seksjonstype: "Plan", planId: e.planId, områdeId: void 0, delområdetype: void 0 };
    case "Delområdetype":
      return { seksjonstype: "Delområdetype", planId: e.planId, områdeId: void 0, delområdetype: e.delområdetype };
    case "Delområdegruppe":
      return { seksjonstype: "Delområdegruppe", planId: e.planId, områdeId: e.gruppeId, delområdetype: e.delområdetype };
    case "Delområde":
      return { seksjonstype: "Delområde", planId: e.planId, områdeId: e.områdeId, delområdetype: e.delområdetype };
    case "Område":
      return { seksjonstype: "Område", planId: e.planId, områdeId: e.områdeId, delområdetype: void 0 };
  }
}
async function et({ seksjonRepo: e }, { sourceGlobalId: r, context: t }, n) {
  const o = await e.fetchByGlobalId(r, n);
  if (!o)
    throw new oe(r);
  const { seksjonstype: s, planId: d, områdeId: a, delområdetype: l } = xr(t);
  return { hideObjectId: (await e.add({
    seksjonstype: s,
    planId: d,
    områdeId: a,
    delområdetype: l,
    tittel: o.tittel,
    tekst: "",
    synlig: !1,
    kommunal: s === "Kommune",
    infoboks: !1,
    topp: !1,
    prioritet: 0,
    overstyrer: !1,
    parentGlobalId: o.globalId,
    parentId: o.id
  })).objectId };
}
async function rt({ seksjonRepo: e }, { hideObjectId: r }) {
  await e.delete(r);
}
async function tt({ seksjonRepo: e }, { ordered: r }) {
  const t = Qe(r);
  t.length !== 0 && await e.reorder(t);
}
async function nt({ områdeRepo: e }, r, t) {
  return e.fetchEgendefinerteForPlan(r.planId, t);
}
function Vt(e) {
  return z(
    e.områdeId,
    e.planId,
    e.egendefinerte,
    e.delområder
  );
}
async function ot({ områdeRepo: e }, r, t) {
  return e.resolveAncestry(r.områdeId, r.planId, t);
}
async function st({ områdeRepo: e }, r) {
  return e.add(r);
}
async function dt({ områdeRepo: e }, r) {
  if (!r.objectId)
    throw new Ce(String(r.objectId));
  return e.update(r);
}
async function at({ områdeRepo: e }, r) {
  await e.delete(r.objectId, r.områdeId);
}
async function it({ elementRepo: e }, r, t) {
  return e.fetchForSection(r.sectionGlobalId, t);
}
async function lt({ elementRepo: e }, r) {
  return e.add(r);
}
async function ut({ elementRepo: e }, r) {
  await e.update(r.objectId, {
    tittel: r.tittel,
    beskrivelse: r.beskrivelse
  });
}
async function mt({ elementRepo: e }, r) {
  await e.delete(r.objectId);
}
async function ct({ elementRepo: e }, r) {
  r.ordered.length !== 0 && await e.reorder([...r.ordered]);
}
async function pt({ områdeRepo: e }, r, t) {
  const n = await e.fetchEgendefinerteForPlan(r.planId, t), o = n.filter((d) => d.kind === "delomradegruppe"), s = n.filter((d) => d.kind === "delomradegruppe-member");
  return { grupper: o, medlemmer: s };
}
async function ft(e, r, t) {
  const { områdeRepo: n } = e, o = r.navn.trim();
  if (!o)
    throw new q("Gruppen må ha et navn", { navn: "Påkrevd" });
  if (r.memberDelområdeIds.length === 0)
    throw new q("Gruppen må ha minst ett medlem", {
      members: "Velg minst ett delområde"
    });
  await rr(e, r.planId, r.memberDelområdeIds, t);
  const s = await n.add({
    navn: o,
    planId: r.planId,
    kind: "delomradegruppe",
    parentType: "Delområdetype",
    parentId: r.delområdetype
  }), d = await Promise.all(
    r.memberDelområdeIds.map(
      (a) => n.add({
        navn: `${s.id}:${a}`,
        planId: r.planId,
        kind: "delomradegruppe-member",
        parentType: "Område",
        parentId: s.id,
        code: a
      })
    )
  );
  return { gruppe: s, members: d };
}
async function yt(e, r, t) {
  return r.delområdeIds.length === 0 ? [] : (await rr(e, r.planId, r.delområdeIds, t, r.gruppeId), Promise.all(
    r.delområdeIds.map(
      (n) => e.områdeRepo.add({
        navn: `${r.gruppeId}:${n}`,
        planId: r.planId,
        kind: "delomradegruppe-member",
        parentType: "Område",
        parentId: r.gruppeId,
        code: n
      })
    )
  ));
}
async function It({ områdeRepo: e }, r, t) {
  if (r.delområdeIds.length === 0)
    return;
  const n = await e.fetchEgendefinerteForPlan(r.planId, t), o = new Set(r.delområdeIds), s = n.filter(
    (d) => d.kind === "delomradegruppe-member" && d.parentId === r.gruppeId && !!d.code && o.has(d.code)
  );
  for (const d of s)
    d.objectId != null && await e.delete(d.objectId, d.id);
}
async function gt({ områdeRepo: e }, r) {
  const t = r.navn.trim();
  if (!t)
    throw new q("Gruppen må ha et navn", { navn: "Påkrevd" });
  return e.update({
    objectId: r.objectId,
    id: r.id,
    planId: r.planId,
    navn: t,
    kind: "delomradegruppe"
  });
}
async function ht(e, r, t) {
  const { områdeRepo: n, seksjonRepo: o } = e, d = (await n.fetchEgendefinerteForPlan(r.planId, t)).filter(
    (a) => a.kind === "delomradegruppe-member" && a.parentId === r.gruppe.id
  );
  for (const a of d)
    a.objectId != null && await n.delete(a.objectId, a.id);
  if (o) {
    const a = `PlanId='${r.planId.replace(/'/g, "''")}' AND Seksjonstype='Delområdegruppe' AND OmrådeId='${r.gruppe.id.replace(/'/g, "''")}'`, l = await o.fetch(a, t);
    for (const i of l)
      await o.delete(i.objectId);
  }
  await n.delete(r.gruppe.objectId, r.gruppe.id);
}
async function rr({ områdeRepo: e }, r, t, n, o) {
  const s = await e.fetchEgendefinerteForPlan(r, n), d = new Set(t), a = [];
  for (const l of s)
    l.kind === "delomradegruppe-member" && (o && l.parentId === o || l.code && d.has(l.code) && a.push(l.code));
  if (a.length > 0)
    throw new q(
      `Delområde(r) er allerede medlem av en annen gruppe: ${a.join(", ")}`,
      { members: "Allerede medlem" }
    );
}
const _ = 6e4, kt = 3e4, wt = (e) => ({
  seksjoner: {
    forContext: (r, t = {}) => {
      const n = t.includeOverriddenAncestors ? "raw" : "filtered";
      return T({
        queryKey: r ? I.seksjoner.forContext(r, n) : I.seksjoner.forContext({ type: "Kommune" }, n),
        queryFn: ({ signal: o }) => {
          const s = {
            context: r,
            ancestry: t.ancestry,
            områdeIdCandidates: t.områdeIdCandidates,
            delområdetypeCandidates: t.delområdetypeCandidates,
            includeOverriddenAncestors: t.includeOverriddenAncestors
          };
          return re(
            {
              seksjonRepo: e.seksjonRepo,
              områdeRepo: e.områdeRepo
            },
            s,
            { signal: o }
          );
        },
        enabled: r != null,
        staleTime: kt
      });
    },
    byGlobalId: (r) => T({
      queryKey: I.seksjoner.byGlobalId(r ?? ""),
      queryFn: ({ signal: t }) => e.seksjonRepo.fetchByGlobalId(r, { signal: t }),
      enabled: !!r,
      staleTime: _
    })
  },
  elementer: {
    forSeksjon: (r) => T({
      queryKey: I.elementer.forSeksjon(r ?? ""),
      queryFn: ({ signal: t }) => {
        if (!e.elementRepo)
          throw new Error("elementRepo ikke konfigurert");
        return it(
          { elementRepo: e.elementRepo },
          { sectionGlobalId: r },
          { signal: t }
        );
      },
      enabled: !!r && e.elementRepo != null,
      staleTime: _
    })
  },
  områder: {
    forPlan: (r) => T({
      queryKey: I.områder.forPlan(r ?? ""),
      queryFn: ({ signal: t }) => {
        if (!e.områdeRepo)
          throw new Error("områdeRepo ikke konfigurert");
        return nt(
          { områdeRepo: e.områdeRepo },
          { planId: r },
          { signal: t }
        );
      },
      enabled: !!r && e.områdeRepo != null,
      staleTime: _
    }),
    ancestry: (r, t) => T({
      queryKey: I.områder.ancestry(r ?? "", t ?? ""),
      queryFn: ({ signal: n }) => {
        if (!e.områdeRepo)
          throw new Error("områdeRepo ikke konfigurert");
        return ot(
          { områdeRepo: e.områdeRepo },
          { områdeId: t, planId: r },
          { signal: n }
        );
      },
      enabled: !!(r && t) && e.områdeRepo != null,
      staleTime: _
    })
  },
  delområdegrupper: {
    forPlan: (r) => T({
      queryKey: I.delområdegrupper.forPlan(r ?? ""),
      queryFn: ({ signal: t }) => {
        if (!e.områdeRepo)
          throw new Error("områdeRepo ikke konfigurert");
        return pt(
          { områdeRepo: e.områdeRepo },
          { planId: r },
          { signal: t }
        );
      },
      enabled: !!r && e.områdeRepo != null,
      staleTime: _
    })
  }
}), jt = Ge("seksjon:arcgisAvvikRepository");
function $(e, ...r) {
  for (const n of r)
    if (e[n] != null)
      return e[n];
  const t = new Set(r.map((n) => n.toLowerCase()));
  for (const [n, o] of Object.entries(e))
    if (o != null && t.has(n.toLowerCase()))
      return o;
}
function Ee(e) {
  if (!(e == null || e === ""))
    return Number(e);
}
function bt(e, r, t) {
  const n = e.attributes ?? {}, o = $(n, "operation");
  if (o !== "add" && o !== "remove")
    return;
  const s = Ee($(n, "teigId"));
  if (s !== void 0 && !Number.isFinite(s))
    return;
  const d = Ee($(n, "matrikkelenhetId"));
  if (d !== void 0 && !Number.isFinite(d))
    return;
  const a = $(n, "omradeId", "omradeid", "områdeid"), l = a == null || a === "" ? r.omradeId : String(a), i = $(n, "omradetype"), u = typeof i == "string" && i !== "" ? i : r.omradetype;
  let m;
  e.geometry && (m = Te.fromJSON(e.geometry), t != null && (m.spatialReference = new qe({ wkid: t })));
  const c = Number($(n, "OBJECTID"));
  return {
    teigId: s,
    matrikkelenhetId: d,
    omradeId: l,
    omradetype: u,
    operation: o,
    geometry: m,
    deltaObjectId: Number.isFinite(c) ? c : void 0
  };
}
function vt(e, r, t) {
  const n = e?.features ?? [], o = /* @__PURE__ */ new Map(), s = [], d = [];
  for (const a of n) {
    const l = bt(a, r, t);
    if (l)
      if (d.push(l), l.matrikkelenhetId === void 0)
        s.push(l);
      else {
        const i = o.get(l.matrikkelenhetId) ?? [];
        i.push(l), o.set(l.matrikkelenhetId, i);
      }
  }
  for (const a of Xe(d))
    jt.warn(
      "Avvik-rader bryter invarianten (add+remove for samme relasjon) — skal ikke kunne skje med slett-motsatt-skrivingen; historiske rader?",
      a.map((l) => l.deltaObjectId)
    );
  return { perMatrikkelenhet: o, utenMatrikkelenhet: s };
}
const A = (e) => e.replaceAll("'", "''"), Dt = (e) => e.endsWith("/") ? e.slice(0, -1) : e;
function Zt(e) {
  const r = Dt(e.eiendommerUrl), t = `${r}/query`, n = `${r}/applyEdits`, o = async (a, l, i) => {
    const u = e.ønsketWkid?.(), m = await F(t, {
      method: "post",
      signal: i?.signal,
      query: {
        f: "json",
        where: a,
        outFields: "OBJECTID,teigId,matrikkelenhetId,omradeid,omradetype,operation",
        returnGeometry: !0,
        ...u != null ? { outSR: u } : {},
        orderByFields: "OBJECTID ASC"
      }
    });
    return vt(m.data, l, u ?? void 0);
  }, s = (a) => {
    const l = a.omradeId === void 0 ? "omradeid IS NULL" : `omradeid = '${A(String(a.omradeId))}'`, i = a.omradetype ? `omradetype = '${A(String(a.omradetype))}'` : "(omradetype IS NULL OR omradetype = 'delomrade')";
    return [
      `teigId = ${a.teigId}`,
      `matrikkelenhetId = ${a.matrikkelenhetId}`,
      l,
      i
    ].join(" AND ");
  }, d = async (a) => {
    a.length !== 0 && await F(n, {
      method: "post",
      query: { f: "json", deletes: a.join(",") }
    });
  };
  return {
    async hentDeltaerForOmråde(a, l, i) {
      const u = `omradeid = '${A(a)}' AND (omradetype = '${A(l)}' OR omradetype IS NULL)`;
      return o(u, { omradeId: a, omradetype: l }, i);
    },
    async hentDeltaerForOmråder(a, l, i) {
      if (a.length === 0)
        return { perMatrikkelenhet: /* @__PURE__ */ new Map(), utenMatrikkelenhet: [] };
      const m = `omradeid IN (${a.map((c) => `'${A(c)}'`).join(",")}) AND (omradetype = '${A(l)}' OR omradetype IS NULL)`;
      return o(m, { omradetype: l }, i);
    },
    async settAvvik(a) {
      const l = await F(t, {
        method: "post",
        query: {
          f: "json",
          where: s(a),
          outFields: "OBJECTID,operation",
          returnGeometry: !1
        }
      }), i = [];
      for (const c of l.data.features ?? []) {
        const p = Number($(c.attributes ?? {}, "OBJECTID")), y = $(c.attributes ?? {}, "operation");
        Number.isFinite(p) && (y === "add" || y === "remove") && i.push({ objectId: p, operation: y });
      }
      const u = i.filter((c) => c.operation === a.operation), m = i.filter((c) => c.operation !== a.operation);
      if (await d(m.map((c) => c.objectId)), u.length > 0) {
        await d(u.slice(1).map((c) => c.objectId));
        return;
      }
      m.length > 0 || await F(n, {
        method: "post",
        query: {
          f: "json",
          adds: JSON.stringify([
            {
              attributes: {
                teigId: a.teigId,
                matrikkelenhetId: a.matrikkelenhetId,
                omradeid: a.omradeId,
                omradetype: a.omradetype,
                operation: a.operation
              },
              geometry: a.geometry.toJSON()
            }
          ])
        }
      });
    },
    async slettAlleForOmråde(a, l) {
      const i = `omradeid = '${A(a)}' AND (omradetype = '${A(l)}' OR omradetype IS NULL)`, m = (await F(t, {
        method: "post",
        query: { f: "json", where: i, returnIdsOnly: !0 }
      })).data.objectIds ?? [];
      await d(m);
    }
  };
}
const se = ur(null), Xt = ({
  client: e,
  children: r
}) => {
  const t = mr(
    () => ({
      client: e,
      queries: wt({
        seksjonRepo: e.seksjoner,
        områdeRepo: e.områder,
        elementRepo: e.elementer,
        delområdegruppeRepo: e.delområdegrupper
      })
    }),
    [e]
  );
  return /* @__PURE__ */ lr(se.Provider, { value: t, children: r });
};
function D() {
  const e = he(se);
  if (!e)
    throw new Error(
      "useSeksjonClient må brukes innenfor en <SeksjonClientProvider>"
    );
  return e.client;
}
function Yt() {
  return he(se)?.client ?? null;
}
function K() {
  const e = he(se);
  if (!e)
    throw new Error(
      "useSeksjonQueries må brukes innenfor en <SeksjonClientProvider>"
    );
  return e.queries;
}
function xt(e, r = {}) {
  const t = K();
  return G(t.seksjoner.forContext(e, r));
}
function en(e) {
  const r = K();
  return G(r.seksjoner.byGlobalId(e));
}
function rn(e) {
  const r = K();
  return G(r.områder.forPlan(e));
}
function tn(e, r) {
  const t = K();
  return G(t.områder.ancestry(e, r));
}
function nn(e) {
  const r = K();
  return G(r.elementer.forSeksjon(e));
}
function on(e) {
  const r = K();
  return G(r.delområdegrupper.forPlan(e));
}
const tr = (e, r) => {
  r ? e.invalidateQueries({
    queryKey: I.seksjoner.forContext(r)
  }) : e.invalidateQueries({ queryKey: I.seksjoner.all });
}, de = (e) => e.invalidateQueries({ queryKey: I.seksjoner.all });
function sn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => Wr({ seksjonRepo: e.seksjoner }, t),
    onSuccess: (t, n) => tr(r, n.context)
  });
}
function dn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => Jr({ seksjonRepo: e.seksjoner }, t),
    // Bredt: delete kan endre arvelinjen (overrides peker til denne).
    onSuccess: () => de(r)
  });
}
function an() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => zr({ seksjonRepo: e.seksjoner, elementRepo: e.elementer }, t),
    // Override-toggle kan endre arvelinjen — invalider bredt.
    onSuccess: () => de(r)
  });
}
function ln() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => et({ seksjonRepo: e.seksjoner }, t),
    onSuccess: () => de(r)
  });
}
function un() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => rt({ seksjonRepo: e.seksjoner }, t),
    onSuccess: () => de(r)
  });
}
function mn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => tt({ seksjonRepo: e.seksjoner }, t),
    onMutate: async (t) => {
      const n = t.context ? I.seksjoner.forContext(t.context) : I.seksjoner.all;
      await r.cancelQueries({ queryKey: n });
      const o = r.getQueryData(n);
      return r.setQueryData(n, (s) => {
        if (!s)
          return s;
        const d = new Map(
          t.ordered.map((a) => [a.objectId, a.prioritet])
        );
        return s.map((a) => {
          const l = d.get(a.objectId);
          return l != null ? { ...a, prioritet: l } : a;
        });
      }), { previous: o };
    },
    onError: (t, n, o) => {
      const s = n.context ? I.seksjoner.forContext(n.context) : I.seksjoner.all;
      o?.previous !== void 0 && r.setQueryData(s, o.previous);
    },
    onSettled: (t, n, o) => tr(r, o.context)
  });
}
const be = (e, r) => {
  e.invalidateQueries({ queryKey: I.områder.forPlan(r) }), e.invalidateQueries({ queryKey: I.områder.all });
};
function cn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.områder.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return st({ områdeRepo: e.områder }, t);
    },
    onSuccess: (t, n) => be(r, n.planId)
  });
}
function pn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.områder.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return dt({ områdeRepo: e.områder }, t);
    },
    onSuccess: (t, n) => {
      n.planId ? be(r, n.planId) : r.invalidateQueries({ queryKey: I.områder.all });
    }
  });
}
function fn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.områder.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return at(
        { områdeRepo: e.områder },
        { objectId: t.objectId, områdeId: t.områdeId }
      );
    },
    onSuccess: (t, n) => {
      n.planId ? be(r, n.planId) : r.invalidateQueries({ queryKey: I.områder.all }), r.invalidateQueries({ queryKey: I.seksjoner.all });
    }
  });
}
const ae = (e, r) => e.invalidateQueries({
  queryKey: I.elementer.forSeksjon(r)
});
function yn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.elementer.all,
    mutationFn: (t) => {
      if (!e.elementer)
        throw new Error("elementer-repository ikke konfigurert");
      return lt({ elementRepo: e.elementer }, t);
    },
    onSuccess: (t, n) => ae(r, n.seksjonsGlobalId)
  });
}
function In() {
  const e = D(), r = b();
  return v({
    mutationKey: I.elementer.all,
    mutationFn: (t) => {
      if (!e.elementer)
        throw new Error("elementer-repository ikke konfigurert");
      return ut(
        { elementRepo: e.elementer },
        { objectId: t.objectId, tittel: t.tittel, beskrivelse: t.beskrivelse }
      );
    },
    onSuccess: (t, n) => {
      n.seksjonGlobalId ? ae(r, n.seksjonGlobalId) : r.invalidateQueries({ queryKey: I.elementer.all });
    }
  });
}
function gn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.elementer.all,
    mutationFn: (t) => {
      if (!e.elementer)
        throw new Error("elementer-repository ikke konfigurert");
      return mt(
        { elementRepo: e.elementer },
        { objectId: t.objectId }
      );
    },
    onSuccess: (t, n) => {
      n.seksjonGlobalId ? ae(r, n.seksjonGlobalId) : r.invalidateQueries({ queryKey: I.elementer.all });
    }
  });
}
function hn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.elementer.all,
    mutationFn: (t) => {
      if (!e.elementer)
        throw new Error("elementer-repository ikke konfigurert");
      return ct(
        { elementRepo: e.elementer },
        { ordered: t.ordered }
      );
    },
    onMutate: async (t) => {
      const n = I.elementer.forSeksjon(t.seksjonGlobalId);
      await r.cancelQueries({ queryKey: n });
      const o = r.getQueryData(n);
      return r.setQueryData(n, (s) => {
        if (!s)
          return s;
        const d = new Map(
          t.ordered.map((a) => [a.objectId, a.prioritet])
        );
        return s.map((a) => {
          const l = d.get(a.objectId);
          return l != null ? { ...a, prioritet: l } : a;
        });
      }), { previous: o };
    },
    onError: (t, n, o) => {
      const s = I.elementer.forSeksjon(n.seksjonGlobalId);
      o?.previous !== void 0 && r.setQueryData(s, o.previous);
    },
    onSettled: (t, n, o) => ae(r, o.seksjonGlobalId)
  });
}
const H = (e, r) => {
  e.invalidateQueries({
    queryKey: I.delområdegrupper.forPlan(r)
  }), e.invalidateQueries({ queryKey: I.områder.forPlan(r) });
};
function kn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.delområdegrupper.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return ft(
        {
          områdeRepo: e.områder,
          seksjonRepo: e.seksjoner
        },
        t
      );
    },
    onSuccess: (t, n) => H(r, n.planId)
  });
}
function wn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.delområdegrupper.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return yt(
        { områdeRepo: e.områder },
        t
      );
    },
    onSuccess: (t, n) => H(r, n.planId)
  });
}
function jn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.delområdegrupper.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return It(
        { områdeRepo: e.områder },
        t
      );
    },
    onSuccess: (t, n) => H(r, n.planId)
  });
}
function bn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.delområdegrupper.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return gt(
        { områdeRepo: e.områder },
        t
      );
    },
    onSuccess: (t, n) => H(r, n.planId)
  });
}
function vn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.delområdegrupper.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return ht(
        {
          områdeRepo: e.områder,
          seksjonRepo: e.seksjoner
        },
        t
      );
    },
    onSuccess: (t, n) => {
      H(r, n.planId), r.invalidateQueries({ queryKey: I.seksjoner.all });
    }
  });
}
class Ot {
  constructor(r = []) {
    this.rows = [], this.nextObjectId = 1e3, this.nextGuid = 1, this.rows.push(...r);
  }
  all() {
    return [...this.rows];
  }
  async fetch(r, t) {
    return this.rows.filter((n) => Ie(r, n));
  }
  async fetchByGlobalId(r) {
    return this.rows.find((t) => t.globalId === r) ?? null;
  }
  async add(r) {
    const t = this.nextObjectId++, n = `gid-${this.nextGuid++}`, o = {
      ...r,
      objectId: t,
      globalId: n
    };
    return this.rows.push(o), o;
  }
  async update(r) {
    const t = this.rows.findIndex((n) => n.globalId === r.globalId);
    if (t === -1)
      throw new Error(`FakeSeksjonRepository: ${r.globalId} not found`);
    return this.rows[t] = { ...r }, this.rows[t];
  }
  async delete(r) {
    const t = this.rows.findIndex((n) => n.objectId === r);
    t !== -1 && this.rows.splice(t, 1);
  }
  async reorder(r) {
    for (const t of r) {
      const n = this.rows.find((o) => o.objectId === t.objectId);
      n && (n.prioritet = t.prioritet);
    }
  }
}
function Ie(e, r) {
  const t = e.trim();
  return !t || t === "1=1" ? !0 : t.includes(" OR ") ? Ae(t, " OR ").some(
    (n) => Ie($e(n), r)
  ) : t.includes(" AND ") ? Ae(t, " AND ").every(
    (n) => Ie($e(n), r)
  ) : St(t, r);
}
function Ae(e, r) {
  const t = [];
  let n = 0, o = "";
  for (let s = 0; s < e.length; s++) {
    if (e[s] === "(" ? n++ : e[s] === ")" && n--, n === 0 && e.slice(s, s + r.length) === r) {
      t.push(o), o = "", s += r.length - 1;
      continue;
    }
    o += e[s];
  }
  return o && t.push(o), t.map((s) => s.trim());
}
function $e(e) {
  const r = e.trim();
  return r.startsWith("(") && r.endsWith(")") ? r.slice(1, -1).trim() : r;
}
const ce = {
  GlobalID: "globalId",
  ObjectId: "objectId",
  PlanId: "planId",
  OmrådeId: "områdeId",
  Id: "id",
  ParentId: "parentId",
  ParentGlobalID: "parentGlobalId",
  Seksjonstype: "seksjonstype",
  Tittel: "tittel",
  Delområdetype: "delområdetype",
  Overstyrer: "overstyrer",
  Synlig: "synlig",
  Kommunal: "kommunal",
  Prioritet: "prioritet"
}, pe = /[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ0-9_]*/.source;
function St(e, r) {
  const t = e.match(new RegExp(`^(${pe})\\s+IN\\s+\\((.+)\\)$`, "i"));
  if (t) {
    const s = ce[t[1]];
    if (!s)
      return !0;
    const d = t[2].split(",").map((l) => l.trim().replace(/^'(.*)'$/, "$1")), a = r[s];
    return d.some(
      (l) => String(a) === l || Number(a) === Number(l)
    );
  }
  const n = e.match(new RegExp(`^(${pe})\\s+IS\\s+(NOT\\s+)?NULL$`, "i"));
  if (n) {
    const s = ce[n[1]];
    if (!s)
      return !0;
    const d = r[s], a = d != null && d !== "";
    return n[2] ? a : !a;
  }
  const o = e.match(new RegExp(`^(${pe})\\s*=\\s*(.+)$`));
  if (o) {
    const s = ce[o[1]];
    if (!s)
      return !0;
    const d = o[2].trim(), a = d.replace(/^'(.*)'$/, "$1"), l = r[s];
    return /^[01]$/.test(d) ? !!l == (d === "1") : String(l ?? "") === a;
  }
  return !0;
}
class Dn {
  constructor(r = []) {
    this.rows = [], this.overridesByTeig = /* @__PURE__ */ new Map(), this.overridesByGeometry = [], this.rows.push(...r);
  }
  /** Test-utility: seed per-teig overstyringer for findOverridesForTeig. */
  seedOverridesForTeig(r, t) {
    this.overridesByTeig.set(r, [...t]);
  }
  /**
   * Test-utility: seed treff for findOverridesByGeometry. Faken bryr seg
   * ikke om input-geometri — testen injiserer alle deltaer (add/remove,
   * delomrade/egendefinert) som geometrien skal returnere.
   */
  seedOverridesByGeometry(r) {
    this.overridesByGeometry = [...r];
  }
  async fetchEgendefinerteForPlan(r) {
    return this.rows.filter((t) => t.planId === r);
  }
  async resolveAncestry(r, t) {
    return {
      planId: t,
      delområdetyper: [],
      delområdeIds: [],
      ancestorOmrådeIds: [],
      gruppeIds: []
    };
  }
  async findOverridesForTeig(r, t) {
    return this.overridesByTeig.get(r) ?? [];
  }
  async findOverridesByGeometry(r) {
    return this.overridesByGeometry;
  }
  async fetchOmrådeByIds(r) {
    const t = new Set(r.map((n) => String(n)));
    return this.rows.filter((n) => t.has(n.id));
  }
  async findEgendefinerteByGeometry(r) {
    const n = (await this.findOverridesByGeometry(r)).filter((o) => o.omradetype === "egendefinert" && o.operation === "add").map((o) => o.omradeId);
    return this.fetchOmrådeByIds(n);
  }
  async add(r) {
    const t = {
      id: `${this.rows.length + 1}`,
      objectId: this.rows.length + 1,
      kind: r.kind ?? "egendefinert",
      navn: r.navn,
      planId: r.planId,
      parentType: r.parentType,
      parentId: r.parentId,
      code: r.code
    };
    return this.rows.push(t), t;
  }
  async update(r) {
    const t = this.rows.find((n) => n.objectId === r.objectId);
    if (!t)
      throw new Error(`FakeOmrådeRepository: objectId=${r.objectId} not found`);
    return Object.assign(t, r), t;
  }
  async delete(r) {
    const t = this.rows.findIndex((n) => n.objectId === r);
    t !== -1 && this.rows.splice(t, 1);
  }
}
class On {
  constructor(r = []) {
    this.rows = [], this.nextObjectId = 1, this.rows.push(...r);
  }
  async fetchForSection(r) {
    return this.rows.filter((t) => t.seksjonsGlobalId === r);
  }
  async add(r) {
    const t = {
      objectId: this.nextObjectId++,
      ...r
    };
    return this.rows.push(t), t;
  }
  async update(r, t) {
    const n = this.rows.find((o) => o.objectId === r);
    n && Object.assign(n, t);
  }
  async delete(r) {
    const t = this.rows.findIndex((n) => n.objectId === r);
    t !== -1 && this.rows.splice(t, 1);
  }
  async reorder(r) {
    for (const t of r) {
      const n = this.rows.find((o) => o.objectId === t.objectId);
      n && (n.prioritet = t.prioritet);
    }
  }
}
class Sn {
  constructor(r = []) {
    this.grupper = [], this.nextObjectId = 1, this.grupper.push(...r);
  }
  async fetchForPlan(r) {
    return this.grupper.filter((t) => t.planId === r);
  }
  async create(r) {
    const t = {
      id: `${this.nextObjectId}`,
      objectId: this.nextObjectId++,
      planId: r.planId,
      delområdetype: r.delområdetype,
      navn: r.navn,
      medlemmer: r.medlemmer ?? []
    };
    return this.grupper.push(t), t;
  }
  async addMembers({
    gruppeId: r,
    medlemmer: t
  }) {
    const n = this.grupper.find((o) => o.id === r);
    n && (n.medlemmer = Array.from(/* @__PURE__ */ new Set([...n.medlemmer, ...t])));
  }
  async removeMembers({
    gruppeId: r,
    medlemmer: t
  }) {
    const n = this.grupper.find((o) => o.id === r);
    if (n) {
      const o = new Set(t);
      n.medlemmer = n.medlemmer.filter((s) => !o.has(s));
    }
  }
  async rename({
    gruppeObjectId: r,
    navn: t
  }) {
    const n = this.grupper.find((o) => o.objectId === r);
    n && (n.navn = t);
  }
  async delete({
    gruppeObjectId: r
  }) {
    const t = this.grupper.findIndex((n) => n.objectId === r);
    t !== -1 && this.grupper.splice(t, 1);
  }
}
class Rt extends Ot {
  async fetch(r) {
    return this.all().filter((t) => ge(r, t));
  }
}
const U = {
  GlobalID: "globalId",
  ObjectId: "objectId",
  PlanId: "planId",
  OmrådeId: "områdeId",
  Id: "id",
  ParentId: "parentId",
  ParentGlobalID: "parentGlobalId",
  Seksjonstype: "seksjonstype",
  Tittel: "tittel",
  Delområdetype: "delområdetype",
  Overstyrer: "overstyrer",
  Synlig: "synlig",
  Kommunal: "kommunal",
  Prioritet: "prioritet"
}, ee = /[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ0-9_]*/.source;
function ge(e, r) {
  const t = Ft(e.trim());
  if (!t || t === "1=1")
    return !0;
  const n = Ne(t, " OR ");
  if (n.length > 1)
    return n.some((s) => ge(s, r));
  const o = Ne(t, " AND ");
  return o.length > 1 ? o.every((s) => ge(s, r)) : Et(t, r);
}
function Ft(e) {
  let r = e.trim();
  for (; r.startsWith("(") && r.endsWith(")"); ) {
    let t = 0, n = !0;
    for (let o = 0; o < r.length; o++)
      if (r[o] === "(")
        t++;
      else if (r[o] === ")" && (t--, t === 0 && o < r.length - 1)) {
        n = !1;
        break;
      }
    if (!n)
      break;
    r = r.slice(1, -1).trim();
  }
  return r;
}
function Ne(e, r) {
  const t = [];
  let n = 0, o = "";
  for (let s = 0; s < e.length; s++) {
    if (e[s] === "(" ? n++ : e[s] === ")" && n--, n === 0 && e.slice(s, s + r.length) === r) {
      t.push(o), o = "", s += r.length - 1;
      continue;
    }
    o += e[s];
  }
  return o && t.push(o), t.map((s) => s.trim());
}
function Et(e, r) {
  const t = (a) => r[U[a]], n = e.match(new RegExp(`^(${ee})\\s+IN\\s+\\((.+)\\)$`, "i"));
  if (n) {
    if (!U[n[1]])
      return !0;
    const a = n[2].split(",").map((i) => i.trim().replace(/^'(.*)'$/, "$1")), l = t(n[1]);
    return a.some((i) => String(l) === i || Number(l) === Number(i));
  }
  const o = e.match(new RegExp(`^(${ee})\\s+IS\\s+(NOT\\s+)?NULL$`, "i"));
  if (o) {
    if (!U[o[1]])
      return !0;
    const a = t(o[1]), l = a != null && a !== "";
    return o[2] ? l : !l;
  }
  const s = e.match(new RegExp(`^(${ee})\\s+LIKE\\s+'(.*)'$`, "i"));
  if (s) {
    if (!U[s[1]])
      return !0;
    const a = t(s[1]);
    if (a == null)
      return !1;
    const l = s[2].replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/%/g, ".*").replace(/_/g, ".");
    return new RegExp(`^${l}$`).test(String(a));
  }
  const d = e.match(new RegExp(`^(${ee})\\s*=\\s*(.+)$`));
  if (d) {
    if (!U[d[1]])
      return !0;
    const a = d[2].trim(), l = a.replace(/^'(.*)'$/, "$1"), i = t(d[1]);
    return /^[01]$/.test(a) ? !!i == (a === "1") : String(i ?? "") === l;
  }
  return !0;
}
const At = {
  Reguleringsplan: 0,
  Bebyggelsesplan: 0,
  Kommunedelplan: 1,
  Kommuneplan: 2
};
function Pe(e, r) {
  return ze(e, Array.from(r));
}
function $t(e, r) {
  const t = new Set(e.map((o) => o.id)), n = /* @__PURE__ */ new Set();
  for (const o of r)
    o.operation !== "add" || o.omradetype !== "delomrade" || t.has(o.omradeId) || n.add(o.omradeId);
  return Array.from(n);
}
class L {
  constructor(r, t) {
    this.rot = r, this.scope = t;
  }
  /** Vanlig veiledningspunkt registrert på dette nivået. */
  veiledning(r, t = {}) {
    return this.rot._leggTilSeksjon(r, this.scope, t), this;
  }
  /**
   * Tilpasning (override) av `parentId` på dette nivået — kopi av kilden med
   * `parentGlobalId` + `overstyrer=true`, slik `toggleSectionOverride`
   * oppretter den.
   */
  tilpasning(r, t = {}) {
    return this.rot._leggTilTilpasning(r, this.scope, t), this;
  }
  /**
   * Skjul `parentId` på dette nivået — hide-metadata-rad (`synlig=false`,
   * `overstyrer=false`, `parentGlobalId`), slik `hideInheritedSection`
   * oppretter den.
   */
  skjul(r, t = {}) {
    return this.rot._leggTilSkjul(r, this.scope, t), this;
  }
}
class Nt extends L {
  constructor(r, t) {
    super(r, { seksjonstype: "Plan", planId: t }), this.planId = t;
  }
  delområdetype(r, t) {
    const n = new L(this.rot, {
      seksjonstype: "Delområdetype",
      planId: this.planId,
      delområdetype: r
    });
    return t?.(n), this;
  }
  delområde(r, t = {}, n) {
    this.rot._registrerDelområde(this.planId, r, t);
    const o = new L(this.rot, {
      seksjonstype: "Delområde",
      planId: this.planId,
      områdeId: r,
      delområdetype: t.type
    });
    return n?.(o), this;
  }
  gruppe(r, t = {}, n) {
    this.rot._registrerGruppe(this.planId, r, t);
    const o = new L(this.rot, {
      seksjonstype: "Delområdegruppe",
      planId: this.planId,
      områdeId: r,
      delområdetype: t.type
    });
    return n?.(o), this;
  }
  egendefinert(r, t = {}, n) {
    this.rot._registrerEgendefinert(this.planId, r, t);
    const o = new L(this.rot, {
      seksjonstype: "Område",
      planId: this.planId,
      områdeId: r
    });
    return n?.(o), this;
  }
}
class Pt {
  constructor() {
    this.seksjonRader = [], this.områdeRader = [], this.delområder = /* @__PURE__ */ new Map(), this.egendefinerte = /* @__PURE__ */ new Map(), this.planer = /* @__PURE__ */ new Map(), this.avvikRader = [], this.objectIdTeller = 1, this.prioritetTeller = 0;
  }
  // ------------------------------------------------------------------
  // Deklarasjon
  // ------------------------------------------------------------------
  /** Kommunal standard-seksjon (gjelder i alle kontekster). */
  kommunalStandard(r, t = {}) {
    return this._leggTilSeksjon(r, { seksjonstype: "Kommune" }, { kommunal: !0, ...t }), this;
  }
  /**
   * Skjul `parentId` på Kommune-nivå — hide-metadata-rad med
   * `seksjonstype='Kommune'` og `kommunal=true`. Siden WHERE-byggeren alltid
   * inkluderer `(Seksjonstype='Kommune' OR Kommunal=1)` vil raden treffes i
   * ALLE kontekster i kommunen, og enrichment-passet markerer kilden som
   * skjult overalt (SKJ-11).
   *
   * Kan bare brukes på seksjoner uten planId/omradeId — speiler at
   * hideInheritedSection kaller contextFields({ type: 'Kommune' }).
   */
  skjulPåKommune(r, t = {}) {
    return this._leggTilSkjul(r, { seksjonstype: "Kommune" }, t), this;
  }
  plan(r, t, n) {
    this.kravIkkeBygget();
    const o = typeof t == "function" ? {} : t ?? {}, s = typeof t == "function" ? t : n, d = o.rang ?? At[(o.planType ?? "Reguleringsplan").replace(/_VN\d+$/, "")] ?? Number.MAX_SAFE_INTEGER;
    return this.planer.set(r, { rang: d }), s?.(new Nt(this, r)), this;
  }
  /**
   * Eiendoms-avvik («delta»-rad i eiendommer-laget). `matrikkelenhetId`
   * utelatt = geometri-/teig-bredt avvik som gjelder alle enheter på teigen.
   */
  avvik(r) {
    return this.kravIkkeBygget(), this.avvikRader.push(r), this;
  }
  // ------------------------------------------------------------------
  // Oppslag / interop
  // ------------------------------------------------------------------
  /**
   * Det delte in-memory-repoet — for tester som vil kjøre virkelige
   * use-cases (f.eks. `hideInheritedSection`/`unhideInheritedSection`)
   * mellom resolve-kall. Etter første tilgang kan scenariet ikke lenger
   * deklarere nye data.
   */
  get seksjonRepo() {
    return this.repo || (this.repo = new Rt(this.seksjonRader)), this.repo;
  }
  /** Slå opp en deklarert seksjon (f.eks. for objectId til use-cases). */
  seksjon(r) {
    const t = this.seksjonRepo.all().find((n) => n.globalId === r);
    if (!t)
      throw new Error(`Scenario: ukjent seksjon '${r}'`);
    return t;
  }
  // ------------------------------------------------------------------
  // Oppløsning
  // ------------------------------------------------------------------
  /**
   * Én-konteksts-oppløsning — speiler citizen sin per-kontekst-query i
   * `useSeksjonData.buildPlanQueries`: ancestry via de virkelige
   * resolve-funksjonene, kandidater fra registreringen, og selve lastingen
   * via `loadSectionsForContext` (ekte WHERE + filter + enrichment).
   */
  async resolveFor(r, t = {}) {
    const n = new Set(t.removedGruppeIds ?? []), o = { seksjonRepo: this.seksjonRepo };
    if (r.type === "Delområde") {
      const s = this.delområder.get(r.områdeId), d = t.delområdetypeCandidates ?? s?.typeCandidates ?? [], a = t.områdeIdCandidates ?? s?.idCandidates, l = {
        ...r,
        // Som i buildPlanQueries: første arealformål-kandidat blir
        // kontekstens delområdetype.
        delområdetype: r.delområdetype ?? d[0]
      }, i = Pe(
        je(
          r.områdeId,
          r.planId,
          this.områderForPlan(r.planId),
          []
        ),
        n
      );
      return re(o, {
        context: l,
        ancestry: i,
        områdeIdCandidates: a,
        delområdetypeCandidates: d
      });
    }
    if (r.type === "Område") {
      const s = Pe(
        z(
          r.områdeId,
          r.planId,
          this.områderForPlan(r.planId),
          []
        ),
        n
      );
      return re(o, { context: r, ancestry: s });
    }
    return re(o, {
      context: r,
      områdeIdCandidates: t.områdeIdCandidates,
      delområdetypeCandidates: t.delområdetypeCandidates
    });
  }
  /**
   * Eiendoms-oppløsning — speiler komposisjonen i `usePlanData` +
   * `useSeksjonData`:
   *
   *   1. `scopeOverridesToMatrikkelenhet` forfiner avvik til søkt enhet.
   *   2. Avvik splittes: egendefinert-add = primær utstrekning; plan-remove
   *      ekskluderer hele planen; resten anvendes per område.
   *   3. `applyPropertyOverrides` per plan for delområder (med addables for
   *      add av delområder teigen ikke treffer geometrisk) og egendefinerte.
   *   4. Kontekst-fanout per effektivt område (delområder først, deretter
   *      egendefinerte shallow-first), Plan-fallback når planen er tom.
   *   5. `mergeUniqueByGlobalId` med plan-type-rang.
   *
   * Returnerer den flate, dedupliserte innbyggerlisten. Hvis alle planer
   * fjernes av plan-nivå-avvik returneres tom liste (appen viser feilmelding
   * i samme situasjon).
   */
  async resolveForEiendom({
    treffer: r,
    matrikkelenhetId: t
  }) {
    const n = Ve(this.avvikRader, t), o = n.filter((f) => f.omradetype === "egendefinert" && f.operation === "add").map((f) => f.omradeId), s = n.filter(
      (f) => f.omradetype !== "plan" && !(f.omradetype === "egendefinert" && f.operation === "add")
    ), d = [], a = (f) => {
      d.includes(f) || d.push(f);
    }, l = [], i = [];
    for (const f of r)
      if ("plan" in f)
        a(f.plan);
      else if ("delområde" in f) {
        const O = this.delområder.get(f.delområde);
        if (!O)
          throw new Error(`Scenario: ukjent delområde '${f.delområde}'`);
        l.push(O), a(O.planId);
      } else {
        const O = this.egendefinerte.get(f.egendefinert);
        if (!O)
          throw new Error(`Scenario: ukjent egendefinert '${f.egendefinert}'`);
        i.push(O.id), a(O.planId);
      }
    for (const f of o)
      this.egendefinerte.get(f) && !i.includes(f) && i.push(f);
    const u = i.map((f) => this.egendefinerte.get(f)).filter((f) => !!f), m = new Set(
      n.filter((f) => f.omradetype === "plan" && f.operation === "remove").map((f) => f.omradeId)
    ), c = d.filter((f) => !m.has(f)), p = this.planTypeRank();
    c.sort((f, O) => p(f) - p(O));
    const y = s.filter((f) => f.omradetype === "delomradegruppe" && f.operation === "remove").map((f) => f.omradeId), g = [];
    for (const f of c) {
      const O = l.filter((w) => w.planId === f), V = $t(O, s).map((w) => this.delområder.get(w)).filter((w) => !!w && w.planId === f), E = ye(O, s, {
        getKey: (w) => ({ omradeId: w.id, omradetype: "delomrade" }),
        addables: V
      }), Z = u.filter(
        (w) => !w.planId || w.planId === f
      ), nr = ye(
        Z,
        s,
        { getKey: (w) => ({ omradeId: w.id, omradetype: "egendefinert" }) }
      ), B = [];
      for (const w of E)
        B.push(
          this.resolveFor(
            { type: "Delområde", planId: f, områdeId: w.id },
            { removedGruppeIds: y }
          )
        );
      const ve = nr.map((w) => ({
        område: w,
        dybde: z(w.id, f, this.områderForPlan(f), []).ancestorOmrådeIds.length
      }));
      ve.sort((w, or) => w.dybde - or.dybde);
      for (const { område: w } of ve)
        B.push(
          this.resolveFor(
            { type: "Område", planId: f, områdeId: w.id },
            { removedGruppeIds: y }
          )
        );
      B.length === 0 && B.push(this.resolveFor({ type: "Plan", planId: f })), g.push(...await Promise.all(B));
    }
    return He(g, p);
  }
  // ------------------------------------------------------------------
  // Interne byggere (kalles fra nivå-klassene)
  // ------------------------------------------------------------------
  /** @internal */
  _leggTilSeksjon(r, t, n) {
    this.kravIkkeBygget(), this.kravUnik(r), this.seksjonRader.push({
      globalId: r,
      objectId: this.objectIdTeller++,
      seksjonstype: t.seksjonstype,
      planId: t.planId,
      områdeId: t.områdeId,
      delområdetype: t.delområdetype,
      tittel: n.tittel ?? r,
      tekst: n.tekst ?? "",
      synlig: n.synlig ?? !0,
      kommunal: n.kommunal ?? t.seksjonstype === "Kommune",
      infoboks: n.infoboks ?? !1,
      topp: n.topp,
      prioritet: n.prioritet ?? this.prioritetTeller++,
      overstyrer: !1
    });
  }
  /** @internal — speiler raden `toggleSectionOverride` oppretter. */
  _leggTilTilpasning(r, t, n) {
    this.kravIkkeBygget();
    const o = this.seksjonRader.find((a) => a.globalId === r);
    if (!o)
      throw new Error(
        `Scenario: tilpasning av ukjent seksjon '${r}' — deklarer kilden først`
      );
    const s = n.id ?? `tilpasset-${r}-${this.nivåId(t)}`;
    this.kravUnik(s);
    const d = t.seksjonstype === "Delområdetype" || t.seksjonstype === "Delområdegruppe" || t.seksjonstype === "Delområde";
    this.seksjonRader.push({
      ...o,
      globalId: s,
      objectId: this.objectIdTeller++,
      seksjonstype: t.seksjonstype,
      planId: t.planId ?? o.planId,
      områdeId: t.områdeId,
      delområdetype: d ? t.delområdetype : o.delområdetype,
      parentGlobalId: r,
      parentId: o.id,
      overstyrer: !n.deaktivert,
      synlig: n.synlig ?? !0,
      tittel: n.tittel ?? o.tittel,
      tekst: n.tekst ?? o.tekst,
      topp: n.topp ?? o.topp,
      prioritet: n.prioritet ?? o.prioritet
    });
  }
  /** @internal — speiler raden `hideInheritedSection` oppretter. */
  _leggTilSkjul(r, t, n) {
    this.kravIkkeBygget();
    const o = this.seksjonRader.find((d) => d.globalId === r);
    if (!o)
      throw new Error(
        `Scenario: skjuling av ukjent seksjon '${r}' — deklarer kilden først`
      );
    const s = n.id ?? `skjul-${r}-${this.nivåId(t)}`;
    this.kravUnik(s), this.seksjonRader.push({
      globalId: s,
      objectId: this.objectIdTeller++,
      seksjonstype: t.seksjonstype,
      planId: t.planId,
      områdeId: t.områdeId,
      delområdetype: t.delområdetype,
      tittel: o.tittel,
      tekst: "",
      synlig: !1,
      kommunal: t.seksjonstype === "Kommune",
      infoboks: !1,
      topp: !1,
      prioritet: 0,
      overstyrer: !1,
      parentGlobalId: r,
      parentId: o.id
    });
  }
  /** @internal */
  _registrerDelområde(r, t, n) {
    this.kravIkkeBygget(), this.delområder.set(t, {
      id: t,
      planId: r,
      typeCandidates: n.typeCandidates ?? (n.type ? [n.type] : []),
      idCandidates: n.idCandidates ?? [t]
    }), n.gruppe && this.leggTilMedlemsrad(r, n.gruppe, t);
  }
  /** @internal */
  _registrerGruppe(r, t, n) {
    this.kravIkkeBygget(), this.områdeRader.push({
      id: t,
      objectId: this.objectIdTeller++,
      kind: "delomradegruppe",
      navn: n.navn ?? t,
      planId: r,
      parentType: "Delområdetype",
      parentId: n.type ?? ""
    });
    for (const o of n.medlemmer ?? [])
      this.leggTilMedlemsrad(r, t, o);
  }
  /** @internal */
  _registrerEgendefinert(r, t, n) {
    this.kravIkkeBygget();
    let o, s;
    n.parent ? (o = "Område", s = n.parent) : n.parentDelområde ? (o = "Delområde", s = n.parentDelområde) : n.parentDelområdetype && (o = "Delområdetype", s = n.parentDelområdetype);
    const d = {
      id: t,
      objectId: this.objectIdTeller++,
      kind: "egendefinert",
      navn: n.navn ?? t,
      planId: r,
      parentType: o,
      parentId: s
    };
    this.områdeRader.push(d), this.egendefinerte.set(t, d);
  }
  // ------------------------------------------------------------------
  // Hjelpere
  // ------------------------------------------------------------------
  leggTilMedlemsrad(r, t, n) {
    this.områdeRader.push({
      id: `medlem-${t}-${n}`,
      objectId: this.objectIdTeller++,
      kind: "delomradegruppe-member",
      navn: n,
      planId: r,
      parentType: "Område",
      parentId: t,
      code: n
    });
  }
  /** Speiler `fetchEgendefinerteForPlan` — hele områdepoolen for planen. */
  områderForPlan(r) {
    return this.områdeRader.filter((t) => t.planId === r);
  }
  planTypeRank() {
    return (r) => r ? this.planer.get(r)?.rang ?? Number.MAX_SAFE_INTEGER : Number.MAX_SAFE_INTEGER;
  }
  nivåId(r) {
    return r.områdeId ?? r.delområdetype ?? r.planId ?? "kommune";
  }
  kravUnik(r) {
    if (this.seksjonRader.some((t) => t.globalId === r))
      throw new Error(`Scenario: duplisert globalId '${r}'`);
  }
  kravIkkeBygget() {
    if (this.repo)
      throw new Error(
        "Scenario: repoet er allerede bygget (etter første resolve/seksjonRepo-tilgang) — deklarer alle data først"
      );
  }
}
function Rn() {
  return new Pt();
}
export {
  P as AbortedError,
  fr as AuthError,
  C as ConfigurationError,
  Sn as FakeDelområdegruppeRepository,
  Dn as FakeOmrådeRepository,
  Ot as FakeSeksjonRepository,
  On as FakeSeksjonelementRepository,
  k as NetworkError,
  pr as OmrådeCycleError,
  Ce as OmrådeNotFoundError,
  cr as OverrideConflictError,
  Pt as Scenario,
  Rt as ScenarioSeksjonRepository,
  Xt as SeksjonClientProvider,
  R as SeksjonError,
  oe as SeksjonNotFoundError,
  wr as SeksjonsTypeValues,
  hr as TOMT_DELTASETT,
  q as ValidationError,
  yt as addMembersToDelområdegruppe,
  lt as addSectionElement,
  kr as anvendDeltaerPåEnhetstre,
  Ze as anvendTeigDeltaer,
  ye as applyPropertyOverrides,
  M as buildInClause,
  _r as buildSectionWhere,
  Ir as canEdit,
  Me as canHide,
  Be as canToggleOverride,
  _e as compareSeksjonOrder,
  Zt as createArcgisAvvikRepository,
  Mr as createArcgisDelområdegruppeRepository,
  Cr as createArcgisOmrådeRepository,
  Fr as createArcgisSeksjonRepository,
  Br as createArcgisSeksjonelementRepository,
  st as createCustomOmråde,
  ft as createDelområdegruppe,
  zt as createSeksjonClient,
  Oe as ctxKey,
  ht as deleteDelområdegruppe,
  at as deleteOmråde,
  Jr as deleteSection,
  mt as deleteSectionElement,
  Wt as domain,
  J as encodeOmrådeNavn,
  Le as enrichSections,
  $r as escapeSqlValue,
  Jt as fetchByGlobalIdOrThrow,
  Xe as finnBruddrader,
  fe as getSectionPosition,
  et as hideInheritedSection,
  yr as isInherited,
  N as isKommunal,
  pt as loadDelområdegrupperForPlan,
  nt as loadOmråderForPlan,
  it as loadSectionElements,
  re as loadSectionsForContext,
  He as mergeUniqueByGlobalId,
  X as områdeFromAttrs,
  vt as parseDeltaFeatures,
  h as qv,
  It as removeMembersFromDelområdegruppe,
  gt as renameDelområdegruppe,
  ct as reorderSectionElements,
  tt as reorderSections,
  je as resolveDelområdeAncestors,
  z as resolveOmrådeAncestors,
  ot as resolveOmrådeAncestry,
  Vt as resolveOmrådeAncestryFrom,
  vr as sanitizeArcgisHtml,
  Wr as saveSection,
  Rn as scenario,
  Ve as scopeOverridesToMatrikkelenhet,
  Ht as seksjonEditableSchema,
  le as seksjonFromAttrs,
  Qr as seksjonInputSchema,
  Ye as seksjonInputToAttrs,
  I as seksjonKeys,
  wt as seksjonQueries,
  Rr as seksjonToAttrs,
  Re as seksjonelementFromAttrs,
  Kr as seksjonelementInputToAttrs,
  ze as stripRemovedGruppeIds,
  zr as toggleSectionOverride,
  rt as unhideInheritedSection,
  dt as updateOmråde,
  wn as useAddDelområdegruppeMedlemmer,
  yn as useAddSeksjonelement,
  kn as useCreateDelområdegruppe,
  cn as useCreateOmråde,
  vn as useDeleteDelområdegruppe,
  fn as useDeleteOmråde,
  dn as useDeleteSeksjon,
  gn as useDeleteSeksjonelement,
  on as useDelområdegrupper,
  ln as useHideInheritedSeksjon,
  tn as useOmrådeAncestry,
  rn as useOmråder,
  jn as useRemoveDelområdegruppeMedlemmer,
  bn as useRenameDelområdegruppe,
  hn as useReorderSeksjonelementer,
  mn as useReorderSeksjoner,
  sn as useSaveSeksjon,
  en as useSeksjon,
  D as useSeksjonClient,
  Yt as useSeksjonClientOptional,
  nn as useSeksjonelementer,
  xt as useSeksjoner,
  an as useToggleSeksjonOverride,
  un as useUnhideInheritedSeksjon,
  pn as useUpdateOmråde,
  In as useUpdateSeksjonelement
};
//# sourceMappingURL=index.mjs.map
